<template>
  <div>
    <CommonOverlay :show="saving" title="Saving..." message="Please wait while settings are saved." />
    <h2 class="page-title mb-5">Settings</h2>
    <b-row>
      <b-col xl="12" xs="12">
        <!-- TAB PANEL START -->
        <section class="tab-panel">
          <b-tabs>
            
            <b-tab title="Overdue Recall" active>
              <div class="text-center">
                <ErrorDisplay/>
                <b-button variant="success" size="sm" @click="saveODSettings" class>Save Overdue Recall Settings</b-button>
              </div>
              <div class="info-section accoun-panel">
                <h3 class="fw-semi-bold sec_header">Accountability</h3>
                <p class="fw-semi-bold">Who is responsible for following up with Overdue Recall patients?</p>
                <multiselect
                  v-if="activeEmployees"
                  v-model="orAccountablePerson"
                  :options="activeEmployees"
                  :multiple="true"
                  :taggable="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Select an Employee"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <img
                        class="option__image"
                        src="../../assets/icons-user-40.png"
                        alt="Team member image"
                      />
                      <span>{{ props.option.Name }}</span>
                      <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <img
                      class="option__image"
                      src="../../assets/icons-user-40.png"
                      alt="Team member image"
                    />
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>

                <p class="fw-semi-bold mt-5">Who are the default providers?</p>
                <div style="margin-bottom: 8px;">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="orDefaultProvider = [...uniqueProviders]">Select All</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary ml-1" @click="orDefaultProvider = []">Clear</button>
                </div>
                <multiselect
                  v-if="providers"
                  v-model="orDefaultProvider"
                  :options="uniqueProviders"
                  :multiple="true"
                  :taggable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :custom-label="providerCustomLabel"
                  label="FName"
                  track-by="ProvNum"
                  :limit="3"
                  :limit-text="count => `and ${count} more`"
                  placeholder="Select providers..."
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__single" v-if="values.length === uniqueProviders.length && !isOpen">
                      All Providers ({{ values.length }})
                    </span>
                  </template>
                </multiselect>

                <!-- THIS IS NO LONGER NECESSARY as of 11/3/2020 as we're now allowing multiple employees. Start of change of owner form for Overdue Recall
                <div class="table-resposive add-more-table" style="padding-top:10px" v-if="orShowAssignments && allSettings">
                  <b-card header="Found existing list">                  
                    <h5 style="padding-top:10px">We found some lists that are already assigned to {{this.employees.filter(e => e.EmployeeID === this.allSettings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue)[0].Name}}. Please select the new person you want to assign to.</h5>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>List</th>
                          <th>Assign To :</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in orListsAssignees" :key="index">
                          <td>  
                            <multiselect
                              v-if="orLists"
                              v-model="item.list"
                              :options="orLists"
                              :multiple="false"
                              :taggable="true"                                                       
                              :show-labels="false"
                              label="Name" 
                              track-by="Name"
                              placeholder="Select List"
                              disabled
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="custom__tag">
                                  <span>{{props.option.Name}}</span>
                                  <i
                                    tabindex="1"
                                    class="multiselect__tag-icon"
                                    @click="removeMember(item,props.option)"
                                  ></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <div class="option__title d-flex">
                                    <span class="option-code">{{props.option.Name}} -</span>
                                    <span>{{props.option.Name}}</span>
                                  </div>
                                </div>
                              </template>
                            </multiselect>
                          </td>
                          <td>                          
                            <multiselect
                              v-model="item.assignedTo"
                              :options="activeEmployees"
                              :multiple="false"
                              :taggable="true"
                              :show-labels="false"
                              label="Name"
                              track-by="Name"
                              placeholder="Select Assignee"
                            >
                              <template slot="singleLabel" slot-scope="props">
                                <span class="custom__tag">
                                  <img
                                    class="option__image"
                                    src="../../assets/icons-user-40.png"
                                    alt="Team member image"
                                  />
                                  <span>{{ props.option.Name }}</span>
                                  <i tabindex="1" class="multiselect__tag-icon"></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <img
                                  class="option__image"
                                  src="../../assets/icons-user-40.png"
                                  alt="Team member image"
                                />
                                <div class="option__desc">
                                  <span class="option__title">{{ props.option.Name }}</span>
                                </div>
                              </template>
                            </multiselect>
                          </td>
                          <td>
                            <i class="fa fa-trash fa-fw ml-3" style="font-size: 16px;"
                            v-if="index>0"/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card>
                </div>                
                End of change of owner form for Overdue Recall -->

              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Goals - Why you should set them for your Team!</h3>
               <b-card
                  class="border-0 mb-xlg background-cover"
                >

                  <div class="d-flex">
                    <i class="glyphicon glyphicon-list-alt  mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Provide a written expectation of daily, weekly, and monthly efforts</p>
                   </div>
                   <div class="d-flex">
                    <i class="fa fa-bar-chart-o  mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Visible goals throughout the platform will allow your team to track progress</p>
                   </div>
                   <div class="d-flex">
                    <i class="fa fa-trophy text-warning mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Provide & track Team Incentives for meeting goals and surpassing them! <span style="color:#218bc3;">(coming soon)</span></p>

                   </div>

                </b-card>
                <div class="goals-checkbox">
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new" /> -->
                    <label for="checkbox-new"><span class="fw-semi-bold">Daily # of calls</span></label>
                    <b-form-input v-model="orDailyCalls"></b-form-input>
                  </b-form-group>
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new1" /> -->
                    <label for="checkbox-new1"><span class="fw-semi-bold">Weekly # of calls</span></label>
                    <b-form-input v-model="orWeeklyCalls"></b-form-input>
                  </b-form-group>
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new2" /> -->
                    <label for="checkbox-new2"><span class="fw-semi-bold">Monthly # of calls</span></label>
                    <b-form-input v-model="orMonthlyCalls"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Follow-ups</h3>

                <div class="maximum-panel">
                  <p class="fw-semi-bold">Maximum #of Follow-ups :
                    <b-form-input type="number" v-model="orMaxNumberOfFollowups" @input="onORFollowupNoChange"></b-form-input>
                  </p>
                  <p class="grey-text">This is the maximum numer of times you want a team member to follow up with a patient for Overdue Recalls.</p>

                </div>
                <h3 class="mb-2 mt-5 fw-semi-bold sec_header">Auto Set frequency of Followup calls :</h3>
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <!-- <input type="radio" id="checkbox-new3" name="followupFrequency" value="1" v-model="orSelectedFollowupFrequency"/> -->
                    <b-form-radio v-model="orSelectedFollowupFrequency" class="custom-radio" name="orfollowupFrequency" value="1"><span class="fw-semi-bold">Each subsequent Follow-up call should occur</span></b-form-radio>
                    <!-- <label for="checkbox-new3">Each subspent Follow-up call should occur</label> -->
                    <select class="custom-select" v-model="orAutoFrequencyDuration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                    </select>
                    <select class="custom-select" v-model="orAutoFrequencyDurationType">
                      <option value="days">day(s)</option>
                      <option value="weeks">Week</option>
                      <option value="months">Month(s)</option>
                    </select>
                    <span class="fw-semi-bold">from previous follow-up.</span>
                  </b-form-group>
                </div>
                
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <!-- <input type="radio" id="checkbox-new4" name="followupFrequency" value="2" v-model="orSelectedFollowupFrequency"/> -->
                    <b-form-radio v-model="orSelectedFollowupFrequency" class="custom-radio" name="orfollowupFrequency" value="2" @input="onORFollowupNoChange"><span class="fw-semi-bold">Custom Frequency :</span></b-form-radio>
                    <!-- <label for="checkbox-new4">Custom Frequency :</label> -->
                  </b-form-group>
                </div>
                <div :class="{'disabled-section':orSelectedFollowupFrequency==='1'}">
                  <p class="fw-semi-bold">After an initial attempt to call the patient:</p>
                <ul class="follow-list">
                  <li v-for="(item,index) in orCustomFollowUps" :key="index">
                    <div class="form-panel-text">
                      Follow up #{{index+1}} Should occur in 
                      <select class="custom-select" v-model="item.duration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                      <select class="custom-select" v-model="item.durationType">
                        <option value="days">Day(s)</option>
                        <option value="weeks">Week(s)</option>
                        <option value="months">Month(s)</option>
                      </select>
                      <span v-if="index !== 0">from follow-up #{{index}}.</span>
                      <!-- <b-button variant="outline-secondary" size="sm" class="ml-2" :disabled="orMaxNumberOfFollowups.length > 0" @click="addFollouwup">+ Add Follow-up</b-button> -->
                      <b-button variant="outline-none" size="sm" class="ml-2 delete-button" :disabled="orMaxNumberOfFollowups.length > 0" @click="removeFollowup(index)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </li>
                </ul>
                </div>

                <!--
                <div class="form-panel-text inline-panel">
                  Allow override by team member ?
                  <b-form-group class="abc-radio allow-override">
                   <b-form-radio-group
                    id="allow-override"
                    v-model="orAllowOverRide"
                    :options="yesNoOptions"
                    name="radio-options"
                  ></b-form-radio-group>
                   </b-form-group>
                </div>
                -->
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                
                <!-- status locked warning message -->
                   <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
               
                <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col cols="3" class="left-status-panel">
                        
                        <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                          
                          
                          <draggable  v-model="orOpenDentalStatuses" group="task">
                          <transition-group type="transition" name="flip-list">
                           
                            <b-badge class="mr-xs" variant="light" v-for="(each) in orOpenDentalStatuses" :key="`or-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                              
                            </b-badge>
                          
                          </transition-group>
                          </draggable>
                         
                        </b-card>

                        <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                        <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in orOpenDentalStatuses" :key="`or-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                            </b-badge>
                        </b-card>

                        <!-- 
                            TODO: TO BE DECIDED FOR FUTURE
                          <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!orShowAddForm" @click="orShowAddForm = !orShowAddForm">+ Add New</b-button> 
                        
                          <b-card class="border-1 mt-4" v-if="orShowAddForm">
                            <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                            <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                            <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                          </b-card>
                        -->
                      </b-col>
                      <b-col>
                        <h6 class="fw-semi-bold mb-4 text-center">Teamio's Status for Logic + Automation</h6>
                        <div class="status-panel">
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                            <draggable v-model="orStatusAppointmentScheduled" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.orStatusAppointmentScheduled.length}">
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusAppointmentScheduled" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable> 
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                              <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusAppointmentScheduled" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                          </b-card>
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <draggable v-model="orStatusRequireFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.orStatusRequireFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusRequireFollowUp" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusRequireFollowUp" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                          </b-card>
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <draggable v-model="orStatusDontFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.orStatusDontFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusDontFollowUp" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in orStatusDontFollowUp" :key="`or-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                  
                </div>

              </div>

              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                <b-form-group class="abc-checkbox">
                  <b-form-checkbox
                    v-model="orCopyToCommLog"
                    unchecked-value="FALSE"
                  >
                    <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                  </b-form-checkbox>
                </b-form-group>
              </div>

              <!--
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                <div class="action-section wiki-action-section mt-4 mb-4">
                  <div class="d-flex">
                    <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                    <p
                      class="fs-13"
                    >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                  </div>
                </div>
                <multiselect
                  v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                  v-model="orSelectedWikiPages"
                  :options="wikiPages[0]"
                  :multiple="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Search within your wiki pages"
                  class="select-wiki-page wiki-multiselect"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>
                      <span>{{ props.option.Name }}</span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              -->

              <div class="text-center mt-4">
                <ErrorDisplay/>
                <b-button variant="success" size="sm" @click="saveODSettings" class>Save Overdue Recall Settings</b-button>
              </div>
            </b-tab>
            <!-- FIRST TAB END -->
            <!-- SECOND TAB START -->
            <b-tab title="Unscheduled Treatment" class="family-table">
              <div class="info-section">
                <div class="text-center">
                <ErrorDisplay/>
                <b-button variant="success" size="sm" @click="saveUTSettings" class>Save Unscheduled Treatment Settings</b-button>
              </div>
                <h3 class="fw-semi-bold sec_header">Accountability</h3>
                <p class="fw-semi-bold">Who is responsible for following up with patients with Unscheduled Treatment?</p>
                <multiselect
                  v-if="activeEmployees"
                  v-model="utAccountablePerson"
                  :options="activeEmployees"
                  :multiple="true"
                  :taggable="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Select an Employee"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <img
                        class="option__image"
                        src="../../assets/icons-user-40.png"
                        alt="Team member image"
                      />
                      <span>{{ props.option.Name }}</span>
                      <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <img
                      class="option__image"
                      src="../../assets/icons-user-40.png"
                      alt="Team member image"
                    />
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>

                <!-- Zero-Fee Procedure Codes.
                     Off for every site unless the office turns it on. Patients whose whole
                     treatment plan is zero-fee are normally filtered off Unscheduled Treatment
                     entirely; nominating codes here brings them back. -->
                <div class="info-section ut-section-divider ut-zero-fee-section">
                  <h3 class="fw-semi-bold sec_header">Zero-Fee Procedure Codes</h3>

                  <!-- The switch sits INLINE with the sentence it controls: on its own with a
                       bare "Off" label it read as an unexplained checkbox. -->
                  <div class="ut-zero-fee-row">
                    <label class="ut-toggle">
                      <input type="checkbox" v-model="utShowZeroFeeCodes" />
                      <span class="ut-toggle-slider"></span>
                    </label>
                    <span class="fw-semi-bold ut-zero-fee-help">
                      Show patients on Unscheduled Treatment even when the only treatment they have
                      planned is one of these no-fee codes. Preventive and diagnostic codes (D0/D1)
                      stay excluded from Unscheduled Treatment either way.
                    </span>
                  </div>

                  <p v-if="utShowZeroFeeCodes" class="fw-semi-bold ut-zero-fee-label">Procedure Codes</p>
                  <multiselect
                    v-if="utShowZeroFeeCodes && procCodes"
                    v-model="utZeroFeeCodes"
                    :options="procCodes"
                    :multiple="true"
                    :taggable="false"
                    :show-labels="false"
                    :custom-label="codeWithDesc"
                    label="ProcCode"
                    track-by="ProcCode"
                    placeholder="Select zero-fee procedure codes"
                    @search-change="searchCodes($event, utZeroFeeCodes)"
                  >
                    <template slot="tag" slot-scope="props">
                      <span class="custom__tag">
                        <span>{{props.option.ProcCode}}</span>
                        <i
                          tabindex="1"
                          class="multiselect__tag-icon"
                          @click="removeZeroFeeCode(props.option)"
                        ></i>
                      </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <div class="option__title d-flex">
                          <span class="option-code">{{ codeWithDesc(props.option) }}</span>
                        </div>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <div class="info-section ut-section-divider">
                  <div class="table-resposive disable">
                    <h3 class="fw-semi-bold sec_header">Custom Code Categories</h3>
                    <table class="table custom-code-table">
                      <thead>
                        <tr>
                          <th>Procedure Codes</th>
                          <th>Category Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in utCustomCodes" :key="index">
                          <td>
                            <span class="mobile-display">Select procedure</span>

                            <multiselect
                              v-if="procCodes"
                              v-model="item.procCodes"
                              :options="procCodes"
                              :multiple="true"
                              :taggable="false"
                              :show-labels="false"
                              :custom-label="codeWithDesc"
                              label="ProcCode"
                              track-by="ProcCode"
                              aria-placeholder="Add Options"
                              @search-change="searchCodes($event, item.procCodes)"
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="custom__tag">
                                  <span>{{props.option.ProcCode}}</span>
                                  <i
                                    tabindex="1"
                                    class="multiselect__tag-icon"
                                    @click="removeCode(item, props.option)"
                                  ></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <div class="option__title d-flex">
                                    <span class="option-code">{{ codeWithDesc(props.option) }}</span>
                                  </div>
                                </div>
                              </template>
                            </multiselect>
                            
                          </td>
                          <td class="production-goal-column">
                            <span class="mobile-display">Category Name</span>
                            <b-form-input v-model="item.categoryName"></b-form-input>
                          </td>
                          <td>
                            <b-button variant="outline-none" size="sm" class="ml-2 delete-button" @click="removeUtCustomCode(index)">
                              <i class="fa fa-trash-o" aria-hidden="true"></i>
                            </b-button>
                          </td>
                        </tr>                        
                      </tbody>
                    </table>
                    <button type="button" class="btn mb-xs mr-xs btn-default ml-3" @click="addUtCustomCode">+ Add More</button>
                  </div>
                </div>


                <!-- End of create custom code -->

                <table class="codes-to-include-exclude">                      
                  <tbody>
                    <tr>
                      <td>
                        <p class="fw-semi-bold mt-5">Codes to Include</p>
                        <multiselect
                              v-if="procCodes"
                              v-model="utSelectedIncludeCodes"
                              :options="procCodes"
                              :multiple="true"
                              :taggable="false"
                              :show-labels="false"
                              :custom-label="codeWithDesc"
                              label="ProcCode"
                              track-by="ProcCode"
                              aria-placeholder="Add Options"
                              @search-change="searchCodes($event, utSelectedIncludeCodes)"                            
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="custom__tag">
                                  <span>{{props.option.ProcCode}}</span>
                                  <i
                                    tabindex="1"
                                    class="multiselect__tag-icon"
                                    @click="removeCodeInclude(props.option)"
                                  ></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <div class="option__title d-flex">
                                    <span class="option-code">{{ codeWithDesc(props.option) }}</span>
                                  </div>
                                </div>
                              </template>
                        </multiselect>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td>
                        <p class="fw-semi-bold mt-5">Custom Tags</p>
                        <multiselect
                              v-if="utCustomCategories"
                              v-model="utSelectedCustomCategoriesForInclude"
                              :options="utCustomCategories"
                              :multiple="true"
                              :taggable="true"                              
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="custom__tag">
                                  <span>{{props.option}}</span>
                                  <i
                                    tabindex="1"
                                    class="multiselect__tag-icon"
                                    @click="removeIncludeCustomTag(props.option)"
                                  ></i>
                                </span>
                              </template>                              
                        </multiselect>
                      </td>                          
                    </tr>
                    <tr>
                      <td>
                        <p class="fw-semi-bold mt-5">Codes to Exclude</p>
                        <multiselect
                            v-if="procCodes"
                            v-model="utSelectedExcludeCodes"
                            :options="procCodes"
                            :multiple="true"
                            :taggable="false"
                            :show-labels="false"
                            :custom-label="codeWithDesc"
                            label="ProcCode"
                            track-by="ProcCode"
                            aria-placeholder="Add Options"
                            @search-change="searchCodes($event, utSelectedExcludeCodes)"                          
                          >
                            <template slot="tag" slot-scope="props">
                              <span class="custom__tag">
                                <span>{{props.option.ProcCode}}</span>
                                <i
                                  tabindex="1"
                                  class="multiselect__tag-icon"
                                  @click="removeCodeExclude(props.option)"
                                ></i>
                              </span>
                            </template>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc">
                                <div class="option__title d-flex">
                                  <span class="option-code">{{ codeWithDesc(props.option) }}</span>
                                </div>
                              </div>
                            </template>
                        </multiselect>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td>
                        <p class="fw-semi-bold mt-5">Custom Tags</p>
                        <multiselect
                              v-if="utCustomCategories"
                              v-model="utSelectedCustomCategoriesForExclude"
                              :options="utCustomCategories"
                              :multiple="true"
                              :taggable="false"
                              :show-labels="true"                              
                            > 
                            <template slot="tag" slot-scope="props">
                              <span class="custom__tag">
                                <span>{{props.option}}</span>
                                <i
                                  tabindex="1"
                                  class="multiselect__tag-icon"
                                  @click="removeExcludeCustomTag(props.option)"
                                ></i>
                              </span>
                            </template>                              
                        </multiselect>
                      </td>
                    </tr>
                  </tbody>
                </table>
                

                <p class="fw-semi-bold mt-5">Who are the default providers?</p>
                <div style="margin-bottom: 8px;">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="utDefaultProvider = [...uniqueProviders]">Select All</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary ml-1" @click="utDefaultProvider = []">Clear</button>
                </div>
                <multiselect
                  v-if="providers"
                  v-model="utDefaultProvider"
                  :options="uniqueProviders"
                  :multiple="true"
                  :taggable="false"
                  :close-on-select="false"
                  :show-labels="false"
                  :custom-label="providerCustomLabel"
                  label="FName"
                  track-by="ProvNum"
                  :limit="3"
                  :limit-text="count => `and ${count} more`"
                  placeholder="Select providers..."
                >
                  <template slot="selection" slot-scope="{ values, isOpen }">
                    <span class="multiselect__single" v-if="values.length === uniqueProviders.length && !isOpen">
                      All Providers ({{ values.length }})
                    </span>
                  </template>
                </multiselect>

                <!-- No longer necessary as of 11/3/2020 Start of change of owner form for Unscheduled Treatment
                <div class="table-resposive add-more-table" style="padding-top:10px" v-if="utShowAssignments && allSettings">
                  <b-card header="Found existing list">
                    <h5 style="padding-top:10px">We found some lists that are already assigned to {{this.employees.filter(e => e.EmployeeID === this.allSettings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue)[0].Name}}. Please select the new person you want to assign to.</h5>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>List</th>
                          <th>Assign To :</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in utListsAssignees" :key="index">
                          <td>  
                            <multiselect
                              v-if="utLists"
                              v-model="item.list"
                              :options="utLists"
                              :multiple="false"
                              :taggable="true"                                                       
                              :show-labels="false"
                              label="Name" 
                              track-by="Name"
                              placeholder="Select List"
                              disabled
                            >
                              <template slot="tag" slot-scope="props">
                                <span class="custom__tag">
                                  <span>{{props.option.Name}}</span>
                                  <i
                                    tabindex="1"
                                    class="multiselect__tag-icon"
                                    @click="removeMember(item,props.option)"
                                  ></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                  <div class="option__title d-flex">
                                    <span class="option-code">{{props.option.Name}} -</span>
                                    <span>{{props.option.Name}}</span>
                                  </div>
                                </div>
                              </template>
                            </multiselect>
                          </td>
                          <td>                          
                            <multiselect
                              v-model="item.assignedTo"
                              :options="activeEmployees"
                              :multiple="false"
                              :taggable="true"
                              :show-labels="false"
                              label="Name"
                              track-by="Name"
                              placeholder="Select Assignee"
                            >
                              <template slot="singleLabel" slot-scope="props">
                                <span class="custom__tag">
                                  <img
                                    class="option__image"
                                    src="../../assets/icons-user-40.png"
                                    alt="Team member image"
                                  />
                                  <span>{{ props.option.Name }}</span>
                                  <i tabindex="1" class="multiselect__tag-icon"></i>
                                </span>
                              </template>
                              <template slot="option" slot-scope="props">
                                <img
                                  class="option__image"
                                  src="../../assets/icons-user-40.png"
                                  alt="Team member image"
                                />
                                <div class="option__desc">
                                  <span class="option__title">{{ props.option.Name }}</span>
                                </div>
                              </template>
                            </multiselect>
                          </td>
                          <td>
                            <i class="fa fa-trash fa-fw ml-3" style="font-size: 16px;"
                            v-if="index>0"/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card>
                </div>                
                End of change of owner form for Unscheduled Treatment -->


              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Goals - Why you should set them for your Team!</h3>
                <b-card
                  class="border-0 mb-xlg background-cover"
                >
                  
                  <div class="d-flex">
                    <i class="glyphicon glyphicon-list-alt  mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Provide a written expectation of daily, weekly, and monthly efforts</p>
                   </div>
                   <div class="d-flex">
                    <i class="fa fa-bar-chart-o  mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Visible goals throughout the platform will allow your team to track progress</p>
                   </div>
                   <div class="d-flex">
                    <i class="fa fa-trophy text-warning mr-3" style="font-size: 20px;"></i>
                    <p class="fs-13 fw-semi-bold">Provide & track Team Incentives for meeting goals and surpassing them! <span style="color:#218bc3;">(coming soon)</span></p>
                   
                   </div>

                </b-card>
                
                <div class="goals-checkbox">
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new" /> -->
                    <label for="checkbox-new"><span class="fw-semi-bold">Daily # of calls</span></label>
                    <b-form-input v-model="utDailyCalls"></b-form-input>
                  </b-form-group>
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new1" /> -->
                    <label for="checkbox-new1"><span class="fw-semi-bold">Weekly # of calls</span></label>
                    <b-form-input v-model="utWeeklyCalls"></b-form-input>
                  </b-form-group>
                  <b-form-group class="abc-checkbox">
                    <!-- <input type="checkbox" id="checkbox-new2" /> -->
                    <label for="checkbox-new2"><span class="fw-semi-bold">Monthly # of calls</span></label>
                    <b-form-input v-model="utMonthlyCalls"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Follow-ups</h3>
                
                <div class="maximum-panel">
                  <p>
                    Maximum #of Follow-ups :
                    <b-form-input type="number" v-model="utMaxNumberOfFollowups" @input="onUTFollowupNoChange"></b-form-input>
                  </p>
                  <p class="grey-text">This is the maximum numer of times you want a team member to follow up with a patient for Unscheduled Treatment.</p>
                  
                </div>
                <h3 class="mb-4 fw-semi-bold sec_header">Auto Set frequency of Followup calls :</h3>
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <!-- <input type="radio" id="checkbox-new3" name="followupFrequency" value="1" v-model="utSelectedFollowupFrequency"/> -->
                    <b-form-radio v-model="utSelectedFollowupFrequency" class="custom-radio" name="utfollowupFrequency" value="1"><span class="fw-semi-bold">Each subsequent Follow-up call should occur</span></b-form-radio>
                    <!-- <label for="checkbox-new3">Each subspent Follow-up call should occur</label> -->
                    <select class="custom-select" v-model="utAutoFrequencyDuration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                    </select>
                    <select class="custom-select" v-model="utAutoFrequencyDurationType">
                      <option value="days">day(s)</option>
                      <option value="weeks">Week</option>
                      <option value="months">Month(s)</option>
                    </select>
                    <span class="fw-semi-bold">from previous follow-up.</span>
                  </b-form-group>
                </div>
                
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <!-- <input type="radio" id="checkbox-new4" name="followupFrequency" value="2" v-model="utSelectedFollowupFrequency"/> -->
                    <b-form-radio v-model="utSelectedFollowupFrequency" class="custom-radio" name="utfollowupFrequency" value="2" @input="onUTFollowupNoChange"><span class="fw-semi-bold">Custom Frequency :</span></b-form-radio>
                    <!-- <label for="checkbox-new4">Custom Frequency :</label> -->
                  </b-form-group>
                </div>
                <div :class="{'disabled-section':utSelectedFollowupFrequency==='1'}">
                <p class="fw-semi-bold">After initial follow up call for an Unscheduled Treatment :</p>
                <ul class="follow-list">
                  <li v-for="(item,index) in utCustomFollowUps" :key="index">
                    <div class="form-panel-text">
                      Follow up #{{index+1}} Should occur
                      <select class="custom-select" v-model="item.duration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                      <select class="custom-select" v-model="item.durationType">
                        <option value="days">Day(s)</option>
                        <option value="weeks">Week(s)</option>
                        <option value="months">Month(s)</option>
                      </select>
                      <span v-if="index !== 0">from follow-up #{{index}}.</span>
                      <b-button variant="outline-secondary" size="sm" class="ml-2" :disabled="utMaxNumberOfFollowups > 0" @click="addUTFollouwup">+ Add Follow-up</b-button>
                      <b-button variant="outline-none" size="sm" class="ml-2 delete-button" :disabled="utMaxNumberOfFollowups.length > 0" @click="removeFollowup(index)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </li>
                </ul>
                </div>
                
                <!--
                <div class="form-panel-text inline-panel">
                  Allow overider by team member ?
                  <b-form-group class="abc-radio allow-override">
                   <b-form-radio-group
                    id="allow-override"
                    v-model="utAllowOverRide"
                    :options="yesNoOptions"
                    name="radio-options"
                  ></b-form-radio-group>
                   </b-form-group>
                  <b-form-group class="abc-radio">
                    <input type="radio" id="checkbox-new5" name="orAllowOverRide" />
                    <label for="checkbox-new5">Yes</label>
                  </b-form-group>
                  <b-form-group class="abc-radio">
                    <input type="radio" id="checkbox-new6" name="orAllowOverRide" />
                    <label for="checkbox-new6">No</label>
                  </b-form-group>
                </div>
                -->
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                
                <!-- status locked warning message -->
                   <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col cols="3" class="left-status-panel">
                        
                        <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                          <draggable v-model="utOpenDentalStatuses" group="task">
                          <transition-group type="transition" name="flip-list">
                            <b-badge class="mr-xs" variant="light" v-for="(each) in utOpenDentalStatuses" :key="`ut-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                              <!-- 
                                TODO: TO BE DECIDED FOR FUTURE
                                <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                              -->
                            </b-badge>
                          </transition-group>
                          </draggable>
                        </b-card>
                        <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                        <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                          <b-badge class="mr-xs" variant="light" v-for="(each) in utOpenDentalStatuses" :key="`ut-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                              <!-- 
                                TODO: TO BE DECIDED FOR FUTURE
                                <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                              -->
                            </b-badge>
                         </b-card>

                        <!-- 
                            TODO: TO BE DECIDED FOR FUTURE
                          <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!orShowAddForm" @click="orShowAddForm = !orShowAddForm">+ Add New</b-button> 
                        
                          <b-card class="border-1 mt-4" v-if="orShowAddForm">
                            <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                            <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                            <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                          </b-card>
                        -->
                      </b-col>
                      <b-col>
                        <h6
                          class="fw-semi-bold mb-4 text-center"
                        >Teamio's Status for Logic + Automation</h6>
                        <div class="status-panel">
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                            <draggable v-model="utStatusAppointmentScheduled" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.utStatusAppointmentScheduled.length}">
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusAppointmentScheduled" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable> 
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusAppointmentScheduled" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                            </b-card>

                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <draggable v-model="utStatusRequireFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.utStatusRequireFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusRequireFollowUp" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusRequireFollowUp" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                            </b-card>


                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <draggable v-model="utStatusDontFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.utStatusDontFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusDontFollowUp" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in utStatusDontFollowUp" :key="`ut-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                            </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                <b-form-group class="abc-checkbox">
                  <b-form-checkbox
                    v-model="utCopyToCommLog"
                    unchecked-value="FALSE"
                  >
                    <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                  </b-form-checkbox>
                  <!-- <input type="checkbox" id="checkbox-new7" />
                  <label
                    for="checkbox-new7"
                  >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                </b-form-group>
              </div>
              <!--
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                <div class="action-section wiki-action-section mt-4 mb-4">
                  <div class="d-flex">
                    <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                    <p
                      class="fs-13"
                    >Attach to Unscheduled Treatment follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                  </div>
                </div>
                <multiselect
                  v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                  v-model="utSelectedWikiPages"
                  :options="wikiPages[0]"
                  :multiple="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Search within your wiki pages"
                  class="select-wiki-page wiki-multiselect"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>
                      <span>{{ props.option.Name }}</span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              -->

              <div class="text-center mt-4">
                <ErrorDisplay/>
                <b-button variant="success" size="sm" @click="saveUTSettings" class>Save Unscheduled Treatment Settings</b-button>
              </div>
            </b-tab>
            <!-- SECOND TAB END -->
            <!-- THIRD TAB START -->
            <b-tab title="Aging" class="family-table">
              <div class="info-section">
                <b-row>
                  <b-col xs="12" xl="12" class="px-xl-3">
                    <b-card class=" bg-light">
                      <div class="text-center mb-3">
                        <ErrorDisplay/>
                        <b-button variant="success" size="sm" @click="saveAgingSettings" class>Save Aging Settings</b-button>
                      </div>
                    <!-- outstanding claims card starts here -->
                    <h2 class="tab_header fw-semi-bold mb-3 w-100">Outstanding Claims</h2>
                    <div class="b-rad-5 px-3 py-1">
                      <h3 class="fw-semi-bold sec_header text-success pt-2 py-0">Accountability</h3>
                      <h6 class="fw-semi-bold">Who is responsible for following up with Outstanding Claims ?</h6>
                      <multiselect
                        v-if="activeEmployees"
                        v-model="ocAccountablePerson"
                        :options="activeEmployees"
                        :multiple="true"
                        :taggable="true"
                        :show-labels="false"
                        label="Name"
                        track-by="Name"
                        placeholder="Select an Employee"
                        class="mb-1"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="custom__tag">
                            <img
                              class="option__image"
                              src="../../assets/icons-user-40.png"
                              alt="Team member image"
                            />
                            <span>{{ props.option.Name }}</span>
                            <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <img
                            class="option__image"
                            src="../../assets/icons-user-40.png"
                            alt="Team member image"
                          />
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.Name }}</span>
                          </div>
                        </template>
                      </multiselect>

                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header text-success">Next Follow-up Period</h3>
                        <ul class="follow-list">
                          <li>
                            <div class="form-panel-text">
                              Next Follow up Should occur in
                              <select class="custom-select" v-model="ocFollowupDuration">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                              <select class="custom-select" v-model="ocFollowupDurationType">
                                <option value="days">Day(s)</option>
                                <option value="weeks">Week(s)</option>
                                <option value="months">Month(s)</option>
                              </select>
                            </div>  
                          </li>       
                        </ul>               
                      </div>

                        <div class="info-section">
                          <h3 class="fw-semi-bold sec_header text-success pt-5 py-0">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                          
                          <!-- status locked warning message -->
                          <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                
                          <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                               
                            <b-container class="bv-example-row mt-3">
                              <b-row>
                                <b-col cols="3" class="left-status-panel">
                                  
                                  <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                                    <h6 class="fw-semi-bold mb-3">Claim Tracking Statuses from Open Dental</h6>
                                    <draggable v-model="ocOpenDentalStatuses" group="task">
                                    <transition-group type="transition" name="flip-list">
                                      <b-badge class="mr-xs" variant="light" v-for="(each) in ocOpenDentalStatuses" :key="`oc-${each.ClientSystemFollowupStatus}`">
                                        {{each.ClientSystemFollowupStatus}}
                                        <!-- 
                                          TODO: TO BE DECIDED FOR FUTURE
                                          <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                                        -->
                                      </b-badge>
                                    </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                                    <h6 class="fw-semi-bold mb-3">Claim Tracking Statuses from Open Dental</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in ocOpenDentalStatuses" :key="`oc-${each.ClientSystemFollowupStatus}`">
                                        {{each.ClientSystemFollowupStatus}}
                                        <!-- 
                                          TODO: TO BE DECIDED FOR FUTURE
                                          <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                                        -->
                                      </b-badge>
                                    </b-card>
                                  <!-- 
                                      TODO: TO BE DECIDED FOR FUTURE
                                    <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!orShowAddForm" @click="orShowAddForm = !orShowAddForm">+ Add New</b-button> 
                                  
                                    <b-card class="border-1 mt-4" v-if="orShowAddForm">
                                      <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                                      <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                                      <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                                    </b-card>
                                  -->
                                </b-col>
                                <b-col>
                                    <b-card  v-if="!isStatusLocked" class="border-1 mt-2 status-list">
                                      <h6 class="fw-semi-bold mb-3">Claim Processed</h6>
                                      <draggable v-model="ocStatusClaimProcessed" group="task">
                                        <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ocStatusClaimProcessed.length}">
                                            <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusClaimProcessed" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                        </transition-group>
                                      </draggable> 
                                    </b-card>
                                    <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                    <b-card  v-else-if="isStatusLocked" class="border-1 mt-2 status-list">
                                      <h6 class="fw-semi-bold mb-3">Claim Processed</h6>
                                      <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusClaimProcessed" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                    <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                      <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                      <draggable v-model="ocStatusRequireFollowUp" group="task">
                                        <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ocStatusRequireFollowUp.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusRequireFollowUp" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                        </transition-group>
                                      </draggable>
                                    </b-card>
                                    <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                    <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                      <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                      <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusRequireFollowUp" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </b-card>
                                    <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                      <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                      <draggable v-model="ocStatusDontFollowUp" group="task">
                                        <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ocStatusDontFollowUp.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusDontFollowUp" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                        </transition-group>
                                      </draggable>
                                    </b-card>
                                    <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                    <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                      <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                      <draggable v-model="ocStatusDontFollowUp" group="task">
                                        <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ocStatusDontFollowUp.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in ocStatusDontFollowUp" :key="`oc-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                        </transition-group>
                                      </draggable>
                                    </b-card>
                                </b-col>
                              </b-row>
                            </b-container>
                          </div>
                        </div>
                    </div>
                    <div class="info-section">
                      <h3 class="fw-semi-bold sec_header text-success">Patient's Communication Log</h3>
                      <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                          v-model="ocCopyToCommLog"
                          unchecked-value="FALSE"
                        >
                          <span class="fw-semi-bold">Copy follow-up Note to patient's communication log in Open Dental ?</span>
                        </b-form-checkbox>
                        <!-- <input type="checkbox" id="checkbox-new7" />
                        <label
                          for="checkbox-new7"
                        >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                      </b-form-group>
                    </div>

                    <div class="info-section">
                      <h3 class="fw-semi-bold sec_header text-success">Claim Custom Status History</h3>
                      <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                          v-model="ocCopyToStatusHistory"
                          unchecked-value="FALSE"
                        >
                          <span class="fw-semi-bold">Copy follow-up Note and Status to the "Status History" tab in Open Dental under "Claim Custom Tracking Status History"</span>
                        </b-form-checkbox>
                        <!-- <input type="checkbox" id="checkbox-new7" />
                        <label
                          for="checkbox-new7"
                        >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                      </b-form-group>
                    </div>

                    <!--
                    <div class="info-section">
                      <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                      <div class="action-section wiki-action-section my-2">
                        <div class="d-flex">
                          <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                          <p
                            class="fs-13"
                          >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                        </div>
                      </div>
                      <multiselect
                        v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                        v-model="ocSelectedWikiPages"
                        :options="wikiPages[0]"
                        :multiple="true"
                        :show-labels="false"
                        label="Name"
                        track-by="Name"
                        placeholder="Search within your wiki pages"
                        class="select-wiki-page wiki-multiselect"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="custom__tag">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            <span>{{ props.option.Name }}</span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <i class="fa fa-file-text-o" aria-hidden="true"></i>
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.Name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    -->
                    </b-card>
                    <!-- outstanding claims card ends here -->

                    <!-- outstanding pre-auth card starts here -->
                    <b-card class="border-1 mt-5 bg-light">
                      <h2 class="fw-semi-bold tab_header w-100">Outstanding Pre-Authorization Claims</h2>
                      <h3 class="fw-semi-bold sec_header fw-semi-bold text-success pt-2 py-0">Accountability</h3>
                      <p class="fw-semi-bold">Who is responsible for following up with Outstanding Pre-Authorization Claims ?</p>
                      <multiselect
                        v-if="activeEmployees"
                        v-model="opAccountablePerson"
                        :options="activeEmployees"
                        :multiple="true"
                        :taggable="true"
                        :show-labels="false"
                        label="Name"
                        track-by="Name"
                        placeholder="Select an Employee"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="custom__tag">
                            <img
                              class="option__image"
                              src="../../assets/icons-user-40.png"
                              alt="Team member image"
                            />
                            <span>{{ props.option.Name }}</span>
                            <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <img
                            class="option__image"
                            src="../../assets/icons-user-40.png"
                            alt="Team member image"
                          />
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.Name }}</span>
                          </div>
                        </template>
                      </multiselect>

                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                        
                        <!-- status locked warning message -->
                        <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                
                        <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                          <b-container class="bv-example-row">
                            <b-row>
                              <b-col cols="3" class="left-status-panel">
                                
                                <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Claim Tracking Statuses from Open Dental</h6>
                                  <draggable v-model="opOpenDentalStatuses" group="task">
                                  <transition-group type="transition" name="flip-list">
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in opOpenDentalStatuses" :key="`op-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                      <!-- 
                                        TODO: TO BE DECIDED FOR FUTURE
                                        <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                                      -->
                                    </b-badge>
                                  </transition-group>
                                  </draggable>
                                </b-card>
                                <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                 <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Claim Tracking Statuses from Open Dental</h6>
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in opOpenDentalStatuses" :key="`op-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                      <!-- 
                                        TODO: TO BE DECIDED FOR FUTURE
                                        <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                                      -->
                                    </b-badge>
                                  </b-card>
                                <!-- 
                                    TODO: TO BE DECIDED FOR FUTURE
                                  <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!orShowAddForm" @click="orShowAddForm = !orShowAddForm">+ Add New</b-button> 
                                
                                  <b-card class="border-1 mt-4" v-if="orShowAddForm">
                                    <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                                    <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                                    <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                                  </b-card>
                                -->
                              </b-col>
                              <b-col>
                                <h6
                                  class="fw-semi-bold mb-4 text-center"
                                >Teamio's Status for Logic + Automation</h6>
                                <div class="status-panel">
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Outstanding Pre-Auth Claim Processed</h6>
                                    <draggable v-model="opStatusClaimProcessed" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.opStatusClaimProcessed.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusClaimProcessed" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable> 
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Outstanding Pre-Auth Claim Processed</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusClaimProcessed" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <draggable v-model="opStatusRequireFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.opStatusRequireFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusRequireFollowUp" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusRequireFollowUp" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <draggable v-model="opStatusDontFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.opStatusDontFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusDontFollowUp" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in opStatusDontFollowUp" :key="`op-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </b-card>
                                </div>
                              </b-col>
                            </b-row>
                          </b-container>
                        </div>
                      </div>
                        <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                        <b-form-group class="abc-checkbox">
                          <b-form-checkbox
                            v-model="opCopyToCommLog"
                            unchecked-value="FALSE"
                          >
                            <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                          </b-form-checkbox>
                          <!-- <input type="checkbox" id="checkbox-new7" />
                          <label
                            for="checkbox-new7"
                          >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                        </b-form-group>
                      </div>

                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header text-success">Claim Custom Status History</h3>
                        <b-form-group class="abc-checkbox">
                          <b-form-checkbox
                            v-model="opCopyToStatusHistory"
                            unchecked-value="FALSE"
                          >
                            <span class="fw-semi-bold">Copy follow-up Note and Status to the "Status History" tab in Open Dental under "Claim Custom Tracking Status History"</span>
                          </b-form-checkbox>
                          <!-- <input type="checkbox" id="checkbox-new7" />
                          <label
                            for="checkbox-new7"
                          >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                        </b-form-group>
                      </div>

                      <!--
                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                        <div class="action-section wiki-action-section my-2">
                          <div class="d-flex">
                            <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                            <p
                              class="fs-13"
                            >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                          </div>
                        </div>
                        <multiselect
                          v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                          v-model="opSelectedWikiPages"
                          :options="wikiPages[0]"
                          :multiple="true"
                          :show-labels="false"
                          label="Name"
                          track-by="Name"
                          placeholder="Search within your wiki pages"
                          class="select-wiki-page wiki-multiselect"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <span class="custom__tag">
                              <i class="fa fa-file-text-o" aria-hidden="true"></i>
                              <span>{{ props.option.Name }}</span>
                            </span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.Name }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                      -->

                    </b-card>
                    <!-- outstanding pre-auth card ends here -->

                    <!-- processed pre-auth card starts here -->
                    <b-card class="border-1 bg-light mt-5">
                      <h2 class="fw-semi-bold tab_header mb-3 w-100">Processed Pre-Authorization Claims</h2>
                      <h3 class="fw-semi-bold sec_header mt-5 text-success pt-2 py-0">Accountability</h3>
                      <p class="fw-semi-bold">Who is responsible for following up with patients whose Pre-Auths have been entered into OpenDental ? </p>
                      <multiselect
                        v-if="activeEmployees"
                        v-model="ppAccountablePerson"
                        :options="activeEmployees"
                        :multiple="true"
                        :taggable="true"
                        :show-labels="false"
                        label="Name"
                        track-by="Name"
                        placeholder="Select an Employee"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="custom__tag">
                            <img
                              class="option__image"
                              src="../../assets/icons-user-40.png"
                              alt="Team member image"
                            />
                            <span>{{ props.option.Name }}</span>
                            <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <img
                            class="option__image"
                            src="../../assets/icons-user-40.png"
                            alt="Team member image"
                          />
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.Name }}</span>
                          </div>
                        </template>
                      </multiselect>




                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Follow-ups</h3>
                        
                        <div class="maximum-panel">
                          <p class="fw-semi-bold">
                            Maximum # of Follow-ups :
                            <b-form-input type="number" v-model="ppMaxNumberOfFollowups" @input="onPPFollowupNoChange"></b-form-input>
                          </p>
                          <p class="grey-text">This is the maximum numer of times you want a team member to follow up with a patient whose PreAuthorizations have been processed & entered into OpenDental AND have pending treatment.</p>
                          
                        </div>
                        <h3 class="mb-2 mt-5 fw-semi-bold sec_header">Auto Set frequency of Followup calls :</h3>
                        <div class="form-panel-text">
                          <b-form-group class="abc-radio">
                            <!-- <input type="radio" id="checkbox-new3" name="followupFrequency" value="1" v-model="orSelectedFollowupFrequency"/> -->
                            <b-form-radio v-model="ppSelectedFollowupFrequency" class="custom-radio" name="ppfollowupFrequency" value="1"><span class="fw-semi-bold">Each subsequent Follow-up call should occur</span></b-form-radio>
                            <!-- <label for="checkbox-new3">Each subspent Follow-up call should occur</label> -->
                            <select class="custom-select" v-model="ppAutoFrequencyDuration">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                            <select class="custom-select" v-model="ppAutoFrequencyDurationType">
                              <option value="days">day(s)</option>
                              <option value="weeks">Week</option>
                              <option value="months">Month(s)</option>
                            </select>
                            <span class="fw-semi-bold">from previous follow-up.</span>
                          </b-form-group>
                        </div>
                        
                        <div class="form-panel-text">
                          <b-form-group class="abc-radio">                            
                            <b-form-radio v-model="ppSelectedFollowupFrequency" class="custom-radio" name="ppfollowupFrequency" value="2" @input="onPPFollowupNoChange"><span class="fw-semi-bold">Custom Frequency :</span></b-form-radio>
                            <!-- <label for="checkbox-new4">Custom Frequency :</label> -->
                          </b-form-group>
                        </div>
                        <div :class="{'disabled-section':ppSelectedFollowupFrequency==='1'}">
                          <p class="fw-semi-bold">After an initial attempt to call for an Overdue Recall patient:</p>
                        <ul class="follow-list">
                          <li v-for="(item,index) in ppCustomFollowUps" :key="index">
                            <div class="form-panel-text">
                              Follow up #{{index+1}} Should occur in 
                              <select class="custom-select" v-model="item.duration">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                              <select class="custom-select" v-model="item.durationType">
                                <option value="days">Day(s)</option>
                                <option value="weeks">Week(s)</option>
                                <option value="months">Month(s)</option>
                              </select>
                              <span v-if="index !== 0">from follow-up #{{index}}.</span>
                              <b-button variant="outline-none" size="sm" class="ml-2 delete-button" :disabled="ppMaxNumberOfFollowups.length > 0" @click="removePPFollowup(index)">
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </li>
                        </ul>
                        </div>
                        
                        <!--
                        <div class="form-panel-text inline-panel">
                          Allow overider by team member ?
                          <b-form-group class="abc-radio allow-override">
                          <b-form-radio-group
                            id="allow-override"
                            v-model="ppAllowOverRide"
                            :options="yesNoOptions"
                            name="radio-options"
                          ></b-form-radio-group>
                          </b-form-group>
                        </div>
                        -->
                      </div>


















                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                        
                        <!-- status locked warning message -->
                        <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                
                        <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                          <b-container class="bv-example-row">
                            <b-row>
                              <b-col cols="3" class="left-status-panel">
                                
                                <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                                  <draggable v-model="ppOpenDentalStatuses" group="task">
                                  <transition-group type="transition" name="flip-list">
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in ppOpenDentalStatuses" :key="`pp-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                      
                                        <!-- <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> -->
                                      
                                    </b-badge>
                                  </transition-group>
                                  </draggable>
                                </b-card>
                                <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in ppOpenDentalStatuses" :key="`pp-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                      
                                        <!-- <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> -->
                                      
                                    </b-badge>
                                  </b-card>
                                <!--
                                  <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!pbShowAddForm" @click="pbShowAddForm = !pbShowAddForm">+ Add New</b-button> 
                                
                                  <b-card class="border-1 mt-4" v-if="pbShowAddForm">
                                    <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                                    <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                                    <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                                  </b-card>
                                -->
                                
                              </b-col>
                              <b-col>
                                <h6
                                  class="fw-semi-bold mb-4 text-center"
                                >Teamio's Status for Logic + Automation</h6>
                                <div class="status-panel">
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                                    <draggable v-model="ppStatusAppointmentScheduled" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ppStatusAppointmentScheduled.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusAppointmentScheduled" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable> 
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusAppointmentScheduled" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <draggable v-model="ppStatusRequireFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ppStatusRequireFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusRequireFollowUp" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusRequireFollowUp" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <draggable v-model="ppStatusDontFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.ppStatusDontFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusDontFollowUp" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in ppStatusDontFollowUp" :key="`pp-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                </div>
                              </b-col>
                            </b-row>
                          </b-container>
                        </div>
                      </div>
                        <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                        <b-form-group class="abc-checkbox">
                          <b-form-checkbox
                            v-model="ppCopyToCommLog"
                            unchecked-value="FALSE"
                          >
                            <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                          </b-form-checkbox>
                          <!-- <input type="checkbox" id="checkbox-new7" />
                          <label
                            for="checkbox-new7"
                          >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                        </b-form-group>
                      </div>

                      <!--
                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                        <div class="action-section wiki-action-section mt-4 mb-4">
                          <div class="d-flex">
                            <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                            <p
                              class="fs-13"
                            >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                          </div>
                        </div>
                        <multiselect
                          v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                          v-model="ppSelectedWikiPages"
                          :options="wikiPages[0]"
                          :multiple="true"
                          :show-labels="false"
                          label="Name"
                          track-by="Name"
                          placeholder="Search within your wiki pages"
                          class="select-wiki-page wiki-multiselect"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <span class="custom__tag">
                              <i class="fa fa-file-text-o" aria-hidden="true"></i>
                              <span>{{ props.option.Name }}</span>
                            </span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.Name }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                      -->

                    </b-card>
                    <!-- processed pre-auth card ends here -->

                    <!-- patient balances card starts here -->
                    <b-card class="border-1">
                      <h2 class="fw-semi-bold tab_header mb-3 w-100">Patient Balances</h2>
                      <h3 class="fw-semi-bold sec_header mt-5 sec_header">Accountability</h3>
                      <p class="fw-semi-bold">Who is responsible for following up with patients with balances on their account? </p>
                      <multiselect
                        v-if="activeEmployees"
                        v-model="pbAccountablePerson"
                        :options="activeEmployees"
                        :multiple="true"
                        :taggable="true"
                        :show-labels="false"
                        label="Name"
                        track-by="Name"
                        placeholder="Select an Employee"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="custom__tag">
                            <img
                              class="option__image"
                              src="../../assets/icons-user-40.png"
                              alt="Team member image"
                            />
                            <span>{{ props.option.Name }}</span>
                            <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <img
                            class="option__image"
                            src="../../assets/icons-user-40.png"
                            alt="Team member image"
                          />
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.Name }}</span>
                          </div>
                        </template>
                      </multiselect>

                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                        <!-- status locked warning message -->
                        <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                        <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                          <b-container class="bv-example-row">
                            <b-row>
                              <b-col cols="3" class="left-status-panel">
                                
                                <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                                  <draggable v-model="pbOpenDentalStatuses" group="task">
                                  <transition-group type="transition" name="flip-list">
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in pbOpenDentalStatuses" :key="`pb-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                        <!-- <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> -->
                                    </b-badge>
                                  </transition-group>
                                  </draggable>
                                </b-card>
                                <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                                  <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in pbOpenDentalStatuses" :key="`pb-${each.ClientSystemFollowupStatus}`">
                                      {{each.ClientSystemFollowupStatus}}
                                        <!-- <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> -->
                                    </b-badge>
                                  </b-card>
                                
                                  <!--
                                  <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!pbShowAddForm" @click="pbShowAddForm = !pbShowAddForm">+ Add New</b-button> 
                                
                                  <b-card class="border-1 mt-4" v-if="pbShowAddForm">
                                    <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                                    <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                                    <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                                  </b-card>
                                  -->
                                
                              </b-col>
                              <b-col>
                                <h6
                                  class="fw-semi-bold mb-4 text-center"
                                >Teamio's Status for Logic + Automation</h6>
                                <div class="status-panel">
                                  <!--
                                  <b-card class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                                    <draggable v-model="pbStatusAppointmentScheduled" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.pbStatusAppointmentScheduled.length}">
                                          <b-badge class="mr-xs" variant="light" v-for="(each) in pbStatusAppointmentScheduled" :key="`pb-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable> 
                                  </b-card>
                                  -->
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <draggable v-model="pbStatusRequireFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.pbStatusRequireFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in pbStatusRequireFollowUp" :key="`pb-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in pbStatusRequireFollowUp" :key="`pb-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                  <b-card v-if="!isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <draggable v-model="pbStatusDontFollowUp" group="task">
                                      <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.pbStatusDontFollowUp.length}">
                                        <b-badge class="mr-xs" variant="light" v-for="(each) in pbStatusDontFollowUp" :key="`pb-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                      </transition-group>
                                    </draggable>
                                  </b-card>
                                  <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                                  <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                                    <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                                    <b-badge class="mr-xs" variant="light" v-for="(each) in pbStatusDontFollowUp" :key="`pb-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                                    </b-card>
                                </div>
                              </b-col>
                            </b-row>
                          </b-container>
                        </div>
                      </div>
                        <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                        <b-form-group class="abc-checkbox">
                          <b-form-checkbox
                            v-model="pbCopyToCommLog"
                            unchecked-value="FALSE"
                          >
                            <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                          </b-form-checkbox>
                          <!-- <input type="checkbox" id="checkbox-new7" />
                          <label
                            for="checkbox-new7"
                          >Copy follow-up Note to patient's communication log in Open Dental ?</label> -->
                        </b-form-group>
                      </div>

                      <!--
                      <div class="info-section">
                        <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                        <div class="action-section wiki-action-section mt-4 mb-4">
                          <div class="d-flex">
                            <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                            <p
                              class="fs-13"
                            >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                          </div>
                        </div>
                        <multiselect
                          v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                          v-model="pbSelectedWikiPages"
                          :options="wikiPages[0]"
                          :multiple="true"
                          :show-labels="false"
                          label="Name"
                          track-by="Name"
                          placeholder="Search within your wiki pages"
                          class="select-wiki-page wiki-multiselect"
                        >
                          <template slot="singleLabel" slot-scope="props">
                            <span class="custom__tag">
                              <i class="fa fa-file-text-o" aria-hidden="true"></i>
                              <span>{{ props.option.Name }}</span>
                            </span>
                          </template>
                          <template slot="option" slot-scope="props">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            <div class="option__desc">
                              <span class="option__title">{{ props.option.Name }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </div>
                      -->

                      <div class="text-center mt-4">
                        <ErrorDisplay/>
                        <b-button variant="success" size="sm" @click="saveAgingSettings" class>Save Aging Settings</b-button>
                      </div>
                    </b-card>
                    <!-- patient balances card ends here -->
                  </b-col>
                </b-row>
              </div>
            </b-tab>
            <!-- THIRD TAB END -->
            <!-- FOURTH TAB START -->
            <b-tab title="Broken Appointment" class="family-table">
              <div class="info-section">
                <div class="text-center">
                  <ErrorDisplay/>
                  <b-button variant="success" size="sm" @click="saveBaSettings" class>Save Broken Appointment Settings</b-button>
                </div>

                <!--
                <h3 v-if="!trackingBA" class="text-danger">Based on your current Open Dental settings, you are not tracking Broken Appointments. Please fix that first.</h3>
                -->

                <h3 class="fw-semi-bold sec_header">Accountability</h3>
                <p class="fw-semi-bold">Who in your office is responsible for making followup calls for Broken Appointments ?</p>
                <multiselect
                  v-if="activeEmployees"
                  v-model="baAccountablePerson"
                  :options="activeEmployees"
                  :multiple="true"
                  :taggable="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Select an Employee"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <img
                        class="option__image"
                        src="../../assets/icons-user-40.png"
                        alt="Team member image"
                      />
                      <span>{{ props.option.Name }}</span>
                      <i tabindex="1" class="multiselect__tag-icon" @click="removeProvider(props.option)"></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <img
                      class="option__image"
                      src="../../assets/icons-user-40.png"
                      alt="Team member image"
                    />
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>

              <!--

              <div class="info-section">
                <h3 class="fw-semi-bold sec_header mt-5">Open Dental Broken Appointments Settings</h3>
               
                <h3 class="fw-semi-bold sec_header mt-5" >Procedure Codes</h3>                
                  <b-form-group class="abc-checkbox">
                    <b-form-checkbox v-model="baProcCodes" value="D9986" disabled>D9986</b-form-checkbox>
                    <b-form-checkbox v-model="baProcCodes" value="D9987" disabled>D9987</b-form-checkbox>
                  </b-form-group>
                <div v-if="baAdjustmentOn === true">
                  <h3 class="fw-semi-bold sec_header mt-5 mb-1 sec_header" >Adjustments</h3>
                  <table class="table table-bordered table-sm mt-lg mb-0 w-fit">
                    <b-form-group class="abc-checkbox w-100">
                    <thead class="text-uppercase">
                        <th>Adjustment</th>
                    </thead>
                    <tbody>
                      <tr v-for="(adjustVal, index) in baAdjustmentsValues" :key="`adjustval-${index}`">
                        <td>
                          <div class="abc-checkbox mb-0 pl-0">
                            <b-form-checkbox class="text-left ml-2 mr-2" v-model="baAdjustSelectedValues" :value="adjustVal.DefNum">{{adjustVal.ItemName}}</b-form-checkbox>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    </b-form-group>
                  </table>
                </div>
              </div>
            -->

              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Follow-ups</h3>
                <div class="action-section mt-4 mb-4">
                  <div class="d-flex">
                    <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                    <p class="fs-13">You may choose to apply filters.</p>
                  </div>
                </div>
                <div class="maximum-panel">
                  <p class="fw-semi-bold">
                    Maximum #of Follow-ups :
                    <b-form-input type="number" v-model="baMaxNumberOfFollowups" @input="onBAFollowupNoChange"></b-form-input>
                  </p>
                  <p class="grey-text">This is the maximum numer of times you want a team member to follow up with a patient after they've missed or have their appointment marked "broken" on your schedule.</p>
                  
                </div>
                <h3 class="mt-5 sec_header">Auto Set frequency of Followup calls :</h3>
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <b-form-radio v-model="baSelectedFollowupFrequency" class="custom-radio" name="baFollowupFrequency" value="1"><span class="fw-semi-bold">Each subsequent Follow-up call should occur</span></b-form-radio>
                    <select class="custom-select" v-model="baAutoFrequencyDuration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                    </select>
                    <select class="custom-select" v-model="baAutoFrequencyDurationType">
                      <option value="days">day(s)</option>
                      <option value="weeks">Week</option>
                      <option value="months">Month(s)</option>
                    </select>
                    <span class="fw-semi-bold">from previous follow-up.</span>
                  </b-form-group>
                </div>
                
                <div class="form-panel-text">
                  <b-form-group class="abc-radio">
                    <b-form-radio v-model="baSelectedFollowupFrequency" class="custom-radio" name="baFollowupFrequency" value="2" @input="onBAFollowupNoChange"><span class="fw-semi-bold">Custom Frequency :</span></b-form-radio>
                  </b-form-group>
                </div>
                <div :class="{'disabled-section':baSelectedFollowupFrequency==='1'}">
                <p class="fw-semi-bold">After initial follow up call for a Broken Appointment patient :</p>
                <ul class="follow-list">
                  <li v-for="(item,index) in baCustomFollowUps" :key="index">
                    <div class="form-panel-text">
                      Follow up #{{index+2}} Should occur
                      <select class="custom-select" v-model="item.duration">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                      <select class="custom-select" v-model="item.durationType">
                        <option value="days">Day(s)</option>
                        <option value="weeks">Week(s)</option>
                        <option value="months">Month(s)</option>
                      </select>
                      from follow-up #{{index+1}}.
                      <b-button variant="outline-secondary" size="sm" class="ml-2" @click="addBAFollouwup">+ Add Follow-up</b-button>
                      <b-button variant="outline-none" size="sm" class="ml-2 delete-button" @click="removeBAFollowup(index)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </li>
                </ul>
                </div>
                
                <!--
                <div class="form-panel-text inline-panel">
                  Allow overider by team member ?
                  <b-form-group class="abc-radio allow-override">
                   <b-form-radio-group
                    id="allow-ba-override"
                    v-model="baAllowOverRide"
                    :options="yesNoOptions"
                    name="ba-allow-override-radio-options"
                  ></b-form-radio-group>
                   </b-form-group>
                </div>
                -->
              </div>
              
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Rules for Follow-up Tasks Logic &amp; Automation</h3>
                
                 <!-- status locked warning message -->
                   <b-alert variant="warning" show v-if="isStatusLocked"><span class="fw-semi-bold stackedMessageForStatusLock"><span class="fw-bold">NOTE:</span> This section is locked for security! Please contact the Teamio team if you need to change this setting!</span></b-alert>
                
                <div class="list-move-panel" v-bind:class="{ statusLockedState: isStatusLocked }">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col cols="3" class="left-status-panel">
                        
                        <b-card v-if="!isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                          <draggable v-model="baOpenDentalStatuses" group="task">
                          <transition-group type="transition" name="flip-list">
                            <b-badge class="mr-xs" variant="light" v-for="(each) in baOpenDentalStatuses" :key="`ba-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                              <!-- 
                                TODO: TO BE DECIDED FOR FUTURE
                                <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                              -->
                            </b-badge>
                          </transition-group>
                          </draggable>
                        </b-card>
                        <!-- status locked warning message -->
                        <b-card v-else-if="isStatusLocked" class="border-1 appointment-panel">
                          <h6 class="fw-semi-bold mb-3">Your Statuses from Open Dental</h6>
                          <b-badge class="mr-xs" variant="light" v-for="(each) in baOpenDentalStatuses" :key="`ba-${each.ClientSystemFollowupStatus}`">
                              {{each.ClientSystemFollowupStatus}}
                              <!-- 
                                TODO: TO BE DECIDED FOR FUTURE
                                <i class="fa fa-trash-o cursor-pointer" @click="removeTask(index)"></i> 
                              -->
                            </b-badge>
                          </b-card>
                        <!-- 
                            TODO: TO BE DECIDED FOR FUTURE
                          <b-button variant="outline-secondary" size="sm" class="mt-4 mb-4" v-if="!orShowAddForm" @click="orShowAddForm = !orShowAddForm">+ Add New</b-button> 
                        
                          <b-card class="border-1 mt-4" v-if="orShowAddForm">
                            <b-form-input v-model="newTask" placeholder="Enetr text here.."></b-form-input>
                            <b-button variant="success" size="sm" class="mt-3 mr-3 mb-0" @click="addNewTask">Add</b-button>
                            <b-button variant="danger" size="sm" class="mt-3 mb-0" @click="cancelTask">Cancel</b-button>
                          </b-card>
                        -->
                      </b-col>
                      <b-col>
                        <h6
                          class="fw-semi-bold mb-4 text-center"
                        >Teamio's Status for Logic + Automation</h6>
                        <div class="status-panel">
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                            <draggable v-model="baStatusAppointmentScheduled" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.baStatusAppointmentScheduled.length}">
                                  <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusAppointmentScheduled" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable> 
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Appointment Scheduled</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusAppointmentScheduled" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                            </b-card>
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <draggable v-model="baStatusRequireFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.baStatusRequireFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusRequireFollowUp" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                          <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Require a Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusRequireFollowUp" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                          </b-card>
                          <b-card v-if="!isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <draggable v-model="baStatusDontFollowUp" group="task">
                              <transition-group type="transition" name="flip-list" tag="div" v-bind:class="{'drop-area' : !this.baStatusDontFollowUp.length}">
                                <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusDontFollowUp" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                              </transition-group>
                            </draggable>
                          </b-card>
                          <!-- IF STATUS ARE LOCKED, THEN JUST PRINT THE BADGES, BUT NO DRAGGABLE -->
                           <b-card v-else-if="isStatusLocked" class="border-1 status-list">
                            <h6 class="fw-semi-bold mb-3">Don't Follow-up</h6>
                            <b-badge class="mr-xs" variant="light" v-for="(each) in baStatusDontFollowUp" :key="`ba-${each.ClientSystemFollowupStatus}`">{{each.ClientSystemFollowupStatus}}</b-badge>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Patient's Communication Log</h3>
                <b-form-group class="abc-checkbox">
                  <b-form-checkbox
                    v-model="baCopyToCommLog"
                    unchecked-value="FALSE"
                  >
                    <span class="fw-semi-bold">Copy follow-up Note to patient's Communication Log in Open Dental ?</span>
                  </b-form-checkbox>
                </b-form-group>
              </div>

              <!--
              <div class="info-section">
                <h3 class="fw-semi-bold sec_header">Wiki Pages / Training documents</h3>
                <div class="action-section wiki-action-section mt-4 mb-4">
                  <div class="d-flex">
                    <i class="fa fa-lightbulb-o text-warning mr-3" style="font-size: 24px;"></i>
                    <p
                      class="fs-13"
                    >Attach to overdue Recall follow-up tasks one or more Wiki Pages on training documents for your team to reforce at the time theyhave doing the follow-ups.</p>
                  </div>
                </div>
                <multiselect
                  v-if="this.wikiPages && this.wikiPages.length > 0 && this.wikiPages[0].length > 0"
                  v-model="baSelectedWikiPages"
                  :options="wikiPages[0]"
                  :multiple="true"
                  :show-labels="false"
                  label="Name"
                  track-by="Name"
                  placeholder="Search within your wiki pages"
                  class="select-wiki-page wiki-multiselect"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span class="custom__tag">
                      <i class="fa fa-file-text-o" aria-hidden="true"></i>
                      <span>{{ props.option.Name }}</span>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.Name }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              -->

              <div class="text-center mt-4">
                <ErrorDisplay/>
                <b-button variant="success" size="sm" @click="saveBaSettings" class>Save Broken Appointment Settings</b-button>
              </div>


            </b-tab>
            <!-- FOURTH TAB END -->


           <!-- Tasks Settings TAB removed — moved to gear icon on /app/todo (see TaskSettings.vue) -->


           <!-- GENERAL TAB START -->
              <b-tab title="General">
                  <div class="text-center">
                    <ErrorDisplay/>
                    <b-button variant="success" size="sm" @click="saveGeneralSettings" class>Save General Settings</b-button>
                  </div>
                  <div class="info-section accoun-panel">
                    <h3 class="fw-semi-bold sec_header">General Settings</h3>

                      <!-- Show Help Button Setting -->
                      <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                          v-model="showHelpButton"
                        >
                          <span class="fw-semi-bold">Show TeamIO Help bot</span>
                          <p class="text-muted small mt-1 mb-0">Show the floating AI help button that appears on all pages</p>
                        </b-form-checkbox>
                      </b-form-group>

                      <!-- Follow-up Optional Note -> OD Comm Log Setting -->
                      <b-form-group class="abc-checkbox">
                        <b-form-checkbox
                          v-model="followupNoteToCommLog"
                        >
                          <span class="fw-semi-bold">Send the Optional Note messages to Open Dental Communication Log</span>
                          <p class="text-muted small mt-1 mb-0">When on, notes typed while initiating a follow-up are copied to the Open Dental Communication Log. Off by default.</p>
                        </b-form-checkbox>
                      </b-form-group>

                      <!-- Patient profile photo → Open Dental imaging category.
                           Only rendered for sites that actually have the feature
                           (Forms + Appointment Reminders), so nobody configures a
                           destination for photos they cannot take. -->
                      <b-form-group v-if="patientProfilePhotoEnabled" class="text-left">
                        <label class="fw-semi-bold" for="patient-photo-imaging-category">Open Dental image category for patient profile photos</label>
                        <select
                          id="patient-photo-imaging-category"
                          class="form-control"
                          data-test="patient-photo-imaging-category"
                          v-model="patientPhotoImagingCategory"
                        >
                          <option value="">Auto — Patient Pictures (recommended)</option>
                          <option v-for="cat in patientPhotoCategories" :key="cat.DefNum" :value="String(cat.DefNum)">{{ cat.ItemName }}</option>
                        </select>
                        <p class="text-muted small mt-1 mb-0">Leave on Auto unless your office keeps patient pictures in a different Open Dental image category. Photos taken from the Patient Profile are saved there.</p>
                      </b-form-group>

                      <!-- Action Center clearing scope (ACTION_CENTER_DISMISS_SCOPE). Admins only: it
                           changes what the whole office sees. Absent = 'office' (see
                           src/utils/actionCenterReadState.js). -->
                      <b-form-group v-if="canEditActionCenterScope" class="text-left ac-dismiss-scope-setting" data-test="action-center-dismiss-scope">
                        <label class="fw-semi-bold" id="action-center-dismiss-scope-label">When someone clears an Action Center alert</label>
                        <b-form-radio-group
                          v-model="actionCenterDismissScope"
                          name="action-center-dismiss-scope"
                          aria-labelledby="action-center-dismiss-scope-label"
                          stacked
                        >
                          <b-form-radio value="office" data-test="action-center-dismiss-scope-office">Clear it for everyone in the office (recommended)</b-form-radio>
                          <b-form-radio value="individual" data-test="action-center-dismiss-scope-individual">Clear it only for the person who cleared it</b-form-radio>
                        </b-form-radio-group>
                        <p class="text-muted small mt-1 mb-0">Alerts that need action (an unanswered text, a question on a treatment plan, a failed payment) clear for everyone once someone handles them, whichever option you choose.</p>
                      </b-form-group>
                  </div>
                </b-tab>
           <!-- GENERAL TAB END -->

           <!-- SLACK TAB START - Only visible to Super Admin -->
              <b-tab v-if="canViewSlack">
                <template #title>Slack <b-badge variant="warning" class="ml-1">SA</b-badge></template>
                <div class="info-section">
                  <h3 class="fw-semi-bold sec_header">
                    <i class="fa fa-slack mr-2" style="color: #4A154B;"></i>
                    Slack Integration
                  </h3>
                  
                  <!-- Loading State -->
                  <div v-if="slackLoading" class="text-center py-5">
                    <b-spinner variant="primary"></b-spinner>
                    <p class="mt-2">Loading Slack status...</p>
                  </div>

                  <!-- Error State -->
                  <b-alert v-if="slackError" variant="danger" show dismissible @dismissed="slackError = null">
                    {{ slackError }}
                  </b-alert>

                  <!-- Not Connected State -->
                  <div v-if="!slackLoading && !slackConnected">
                    <b-card class="border-1 mb-4">
                      <div class="d-flex align-items-center">
                        <i class="fa fa-info-circle text-info mr-3" style="font-size: 24px;"></i>
                        <div>
                          <h5 class="mb-1">Connect Your Slack Workspace</h5>
                          <p class="mb-0 text-muted">
                            Connect your practice's Slack workspace to enable Slack notifications in your workflows.
                            You'll be able to send automated messages to any channel in your workspace.
                          </p>
                        </div>
                      </div>
                    </b-card>

                    <div class="text-center">
                      <b-button 
                        type="button"
                        variant="primary" 
                        size="lg" 
                        @click.prevent.stop="connectSlack($event)"
                        :disabled="slackLoading"
                      >
                        <i class="fa mr-2" :class="slackLoading ? 'fa-spinner fa-spin' : 'fa-slack'"></i>
                        {{ slackLoading ? 'Connecting...' : 'Connect to Slack' }}
                      </b-button>
                    </div>
                  </div>

                  <!-- Connected State -->
                  <div v-if="!slackLoading && slackConnected">
                    <b-card class="border-1 mb-4 bg-light">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                          <i class="fa fa-check-circle text-success mr-3" style="font-size: 32px;"></i>
                          <div>
                            <h5 class="mb-1">Connected to Slack</h5>
                            <p class="mb-0">
                              <strong>Workspace:</strong> {{ slackWorkspaceName }}
                            </p>
                          </div>
                        </div>
                        <b-button 
                          type="button"
                          variant="outline-danger" 
                          size="sm"
                          @click.prevent="disconnectSlack"
                          :disabled="slackLoading"
                        >
                          <i class="fa fa-unlink mr-1"></i>
                          Disconnect
                        </b-button>
                      </div>
                    </b-card>

                    <!-- How to Invite Bot -->
                    <b-alert variant="info" show class="mt-4">
                      <h5 class="alert-heading"><i class="fa fa-info-circle mr-2"></i>How to Add Channels</h5>
                      <p class="mb-2">To send messages to a Slack channel, the Teamio bot must be invited to that channel first:</p>
                      <ol class="mb-0 pl-3">
                        <li>Open the channel in Slack</li>
                        <li>Type <code>/invite @Teamio</code> and press Enter</li>
                        <li>Click "Refresh Channels" below to see the updated list</li>
                      </ol>
                    </b-alert>

                    <!-- Available Channels -->
                    <div class="mt-4">
                      <h4 class="fw-semi-bold">Available Channels</h4>
                      <p class="text-muted">
                        These are the channels where the Teamio bot can send messages.
                      </p>
                      
                      <b-button 
                        type="button"
                        variant="outline-primary" 
                        size="sm" 
                        class="mb-3"
                        @click.prevent.stop="refreshSlackChannels($event)"
                        :disabled="slackLoading"
                      >
                        <i class="fa fa-refresh mr-1" :class="{ 'fa-spin': slackLoading }"></i>
                        {{ slackLoading ? 'Refreshing...' : 'Refresh Channels' }}
                      </b-button>

                      <div v-if="slackChannels.length > 0" class="table-responsive">
                        <table class="table table-sm table-hover">
                          <thead>
                            <tr>
                              <th>Channel</th>
                              <th>Type</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="channel in slackChannels" :key="channel.id">
                              <td>
                                <i :class="channel.is_private ? 'fa fa-lock' : 'fa fa-hashtag'" class="mr-2 text-muted"></i>
                                {{ channel.name }}
                              </td>
                              <td>
                                <b-badge :variant="channel.is_private ? 'warning' : 'info'">
                                  {{ channel.is_private ? 'Private' : 'Public' }}
                                </b-badge>
                              </td>
                              <td>
                                <b-badge :variant="channel.is_member ? 'success' : 'secondary'">
                                  {{ channel.is_member ? 'Bot Joined' : 'Not Joined' }}
                                </b-badge>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <small class="text-muted">
                          <i class="fa fa-info-circle mr-1"></i>
                          Channels marked "Not Joined" - use <code>/invite @Teamio</code> in Slack to add the bot.
                        </small>
                      </div>

                      <b-alert v-else-if="!slackLoading" variant="warning" show>
                        <i class="fa fa-exclamation-triangle mr-2"></i>
                        No channels found. Use <code>/invite @Teamio</code> in any Slack channel to add the bot, then click "Refresh Channels".
                      </b-alert>
                    </div>

                    <!-- Test Message Section -->
                    <div class="mt-4">
                      <h4 class="fw-semi-bold">Send Test Message</h4>
                      <b-card class="border-1">
                        <b-form-group label="Select Channel" label-class="fw-semi-bold">
                          <b-form-select v-model="slackTestChannel" :options="slackChannelOptions">
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- Select a channel --</b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-muted">
                            Channels with ✓ have the bot joined. Others may require <code>/invite @Teamio</code> first.
                          </small>
                        </b-form-group>

                        <b-form-group label="Message" label-class="fw-semi-bold">
                          <b-form-textarea 
                            v-model="slackTestMessage" 
                            placeholder="Enter a test message..."
                            rows="3"
                          ></b-form-textarea>
                        </b-form-group>

                        <b-button 
                          type="button"
                          variant="success" 
                          @click.prevent.stop="sendTestSlackMessage($event)"
                          :disabled="!slackTestChannel || !slackTestMessage || slackLoading"
                        >
                          <i class="fa mr-1" :class="slackLoading ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                          {{ slackLoading ? 'Sending...' : 'Send Test Message' }}
                        </b-button>
                      </b-card>
                    </div>
                  </div>
                </div>
              </b-tab>
           <!-- SLACK TAB END -->

           <!-- MANGO VOICE TAB START -->
              <b-tab title="Mango Voice">
                <DemoUnavailable v-if="isDemoSession" />
                <div v-else class="info-section">
                  <h3 class="fw-semi-bold sec_header">
                    <i class="fa fa-phone mr-2" style="color: #2ECC71;"></i>
                    Mango Voice Integration
                  </h3>

                  <!-- Loading State -->
                  <div v-if="mangoVoiceLoading" class="text-center py-5">
                    <b-spinner variant="primary"></b-spinner>
                    <p class="mt-2">Loading Mango Voice settings...</p>
                  </div>

                  <!-- Error State -->
                  <b-alert v-if="mangoVoiceError" variant="danger" show dismissible @dismissed="mangoVoiceError = null">
                    {{ mangoVoiceError }}
                  </b-alert>

                  <div v-if="!mangoVoiceLoading">
                    <!-- Info Card -->
                    <b-card class="border-1 mb-4">
                      <div class="d-flex align-items-center">
                        <i class="fa fa-info-circle text-info mr-3" style="font-size: 24px;"></i>
                        <div>
                          <h5 class="mb-1">Connect Your Mango Voice System</h5>
                          <p class="mb-0 text-muted">
                            Configure your Mango Voice webhook to receive call events (like missed calls)
                            and trigger automated workflows in Teamio.
                          </p>
                        </div>
                      </div>
                    </b-card>

                    <!-- Webhook URL Section -->
                    <div class="mt-4">
                      <h4 class="fw-semi-bold">Webhook URL</h4>
                      <p class="text-muted">
                        Use this URL in your Mango Voice webhook configuration to send events to Teamio.
                      </p>

                      <b-input-group class="mb-3">
                        <b-form-input
                          :value="mangoVoiceWebhookUrl"
                          readonly
                          class="bg-light"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="outline-primary"
                            @click="copyToClipboard(mangoVoiceWebhookUrl, 'Webhook URL')"
                          >
                            <i class="fa fa-copy mr-1"></i>
                            Copy
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>

                    <!-- Security Token Section -->
                    <div class="mt-4">
                      <h4 class="fw-semi-bold">Security Token</h4>
                      <p class="text-muted">
                        This token authenticates webhook requests from Mango Voice. Include it as a query parameter in your webhook URL.
                      </p>

                      <!-- Not Configured State -->
                      <div v-if="!mangoVoiceToken">
                        <b-alert variant="warning" show>
                          <i class="fa fa-exclamation-triangle mr-2"></i>
                          No security token configured. Generate one to enable the webhook.
                        </b-alert>
                        <b-button
                          variant="success"
                          @click="generateMangoVoiceToken"
                          :disabled="mangoVoiceLoading"
                        >
                          <i class="fa fa-key mr-1"></i>
                          Generate Security Token
                        </b-button>
                      </div>

                      <!-- Configured State -->
                      <div v-else>
                        <b-card class="border-1 mb-3 bg-light">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="flex-grow-1 mr-3">
                              <label class="mb-1 text-muted small">Your Security Token:</label>
                              <b-input-group>
                                <b-form-input
                                  :value="mangoVoiceTokenVisible ? mangoVoiceToken : '••••••••••••••••••••••••'"
                                  readonly
                                  :type="mangoVoiceTokenVisible ? 'text' : 'password'"
                                  class="bg-white"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-button
                                    variant="outline-secondary"
                                    @click="mangoVoiceTokenVisible = !mangoVoiceTokenVisible"
                                    :title="mangoVoiceTokenVisible ? 'Hide token' : 'Show token'"
                                  >
                                    <i class="fa" :class="mangoVoiceTokenVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
                                  </b-button>
                                  <b-button
                                    variant="outline-primary"
                                    @click="copyToClipboard(mangoVoiceToken, 'Security Token')"
                                  >
                                    <i class="fa fa-copy mr-1"></i>
                                    Copy
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>
                            </div>
                          </div>
                          <div class="mt-3">
                            <b-button
                              variant="outline-warning"
                              size="sm"
                              @click="regenerateMangoVoiceToken"
                              :disabled="mangoVoiceLoading"
                            >
                              <i class="fa fa-refresh mr-1"></i>
                              Regenerate Token
                            </b-button>
                            <small class="text-muted ml-2">
                              Warning: Regenerating will invalidate the current token.
                            </small>
                          </div>
                        </b-card>

                        <!-- Full Webhook URL with Token -->
                        <div class="mt-3">
                          <label class="fw-semi-bold">Complete Webhook URL (with token):</label>
                          <b-input-group>
                            <b-form-input
                              :value="mangoVoiceFullWebhookUrl"
                              readonly
                              class="bg-light small"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                variant="outline-primary"
                                @click="copyToClipboard(mangoVoiceFullWebhookUrl, 'Complete Webhook URL')"
                              >
                                <i class="fa fa-copy mr-1"></i>
                                Copy
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </div>
                      </div>
                    </div>

                    <!-- Setup Instructions -->
                    <b-alert variant="info" show class="mt-4">
                      <h5 class="alert-heading"><i class="fa fa-list-ol mr-2"></i>Setup Instructions</h5>
                      <ol class="mb-0 pl-3">
                        <li>Generate a security token above (if you haven't already)</li>
                        <li>Copy the complete webhook URL (includes your token)</li>
                        <li>Log in to your Mango Voice admin panel</li>
                        <li>Navigate to Webhooks or Integrations settings</li>
                        <li>Add a new webhook and paste the complete URL</li>
                        <li>Configure which events to send (e.g., missed calls, voicemails)</li>
                        <li>Save your webhook configuration in Mango Voice</li>
                        <li>Create a workflow in Teamio with "Mango Voice" as the trigger</li>
                      </ol>
                    </b-alert>

                    <!-- Available Placeholders -->
                    <div class="mt-4">
                      <h4 class="fw-semi-bold">Available Placeholders for Workflows</h4>
                      <p class="text-muted">
                        When creating workflow actions (like Assign Task), you can use these placeholders in your messages:
                      </p>
                      <table class="table table-sm table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th>Placeholder</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><code v-pre>{{callerNumber}}</code></td>
                            <td>Phone number of the caller</td>
                          </tr>
                          <tr>
                            <td><code v-pre>{{callerId}}</code></td>
                            <td>Caller ID name (if available)</td>
                          </tr>
                          <tr>
                            <td><code v-pre>{{callTime}}</code></td>
                            <td>Date and time of the call</td>
                          </tr>
                          <tr>
                            <td><code v-pre>{{dialedNumberName}}</code></td>
                            <td>Name of the number that was dialed</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-tab>
           <!-- MANGO VOICE TAB END -->

           <!-- EMAIL REPORTS TAB START - Only visible to Admin, Manager, Super Admin -->
              <b-tab v-if="canViewEmailReports" title="Email Reports">
                <div class="info-section">
                  <EmailReportsTab @saving="val => saving = val" />
                </div>
              </b-tab>
           <!-- EMAIL REPORTS TAB END -->

           <!-- EMAIL SETTINGS TAB START - Only visible to Admin, Manager, Super Admin -->
              <b-tab v-if="canViewEmailSettings" title="Email">
                <div class="info-section">
                  <EmailSettingsTab />
                </div>
              </b-tab>
           <!-- EMAIL SETTINGS TAB END -->

           <!-- PAYMENTS TAB START - Visible to Super Admin + Admin (office self-serves setup) -->
              <b-tab v-if="canViewPaymentSettings">
                <template #title>Payments</template>
                <div class="info-section">
                  <PaymentSettings />
                </div>
              </b-tab>
           <!-- PAYMENTS TAB END -->

           <!-- BANK CONNECTION (PLAID) TAB START - Only visible to Super Admin -->
              <b-tab v-if="canViewBankConnection" @click="loadPlaidStatus()">
                <template #title>Bank Connection <b-badge variant="warning" class="ml-1">SA</b-badge></template>
                <div class="info-section">

                  <!-- Loading -->
                  <div v-if="plaidLoading" class="text-center py-5">
                    <b-spinner variant="primary"></b-spinner>
                    <p class="mt-2 text-muted">Loading...</p>
                  </div>

                  <!-- Error Alert -->
                  <b-alert v-if="plaidError" variant="danger" show dismissible @dismissed="plaidError = null" class="mb-3">
                    {{ plaidError }}
                  </b-alert>

                  <!-- Not Connected -->
                  <div v-if="!plaidLoading && (!plaidConnection || !plaidConnection.connected)">
                    <b-card class="border-1 mb-4">
                      <div class="d-flex align-items-start">
                        <i class="fa fa-university fa-2x text-primary mr-3 mt-1"></i>
                        <div>
                          <h5 class="mb-1">Connect Bank Account</h5>
                          <p class="text-muted mb-0">
                            Connect your practice's bank account to automatically track insurance deposits
                            and reconcile payments. Your bank credentials are handled securely by Plaid — we
                            never see your login information.
                          </p>
                        </div>
                      </div>
                    </b-card>

                    <b-button variant="primary" size="lg" @click="connectPlaid" :disabled="plaidLoading">
                      <i class="fa fa-link mr-2"></i>
                      Connect Bank Account
                    </b-button>
                  </div>

                  <!-- Connected -->
                  <div v-if="!plaidLoading && plaidConnection && plaidConnection.connected">
                    <b-card class="border-1 mb-4">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="d-flex align-items-start">
                          <i class="fa fa-check-circle fa-2x text-success mr-3 mt-1"></i>
                          <div>
                            <h5 class="mb-1">
                              {{ plaidConnection.institution_name || 'Bank Account' }}
                              <b-badge :variant="plaidConnection.status === 'active' ? 'success' : 'danger'" class="ml-2">
                                {{ plaidConnection.status }}
                              </b-badge>
                            </h5>
                            <p class="mb-1">
                              {{ plaidConnection.account_name || 'Account' }}
                              <span v-if="plaidConnection.account_mask" class="text-muted">
                                ····{{ plaidConnection.account_mask }}
                              </span>
                            </p>
                            <small class="text-muted">
                              Connected {{ formatDateTimeWitTz(plaidConnection.connected_at, allSettings.GENERAL_TIMEZONE ? allSettings.GENERAL_TIMEZONE.PropertyValue : 'America/New_York') }}
                              <span v-if="plaidConnection.last_synced_at">
                                · Last synced {{ formatDateTimeWitTz(plaidConnection.last_synced_at, allSettings.GENERAL_TIMEZONE ? allSettings.GENERAL_TIMEZONE.PropertyValue : 'America/New_York') }}
                              </span>
                              <span v-if="plaidConnection.transaction_count !== undefined">
                                · {{ plaidConnection.transaction_count }} transactions
                              </span>
                            </small>
                          </div>
                        </div>
                        <b-button variant="outline-danger" size="sm" @click="disconnectPlaid" :disabled="plaidLoading">
                          <i class="fa fa-times mr-1"></i> Disconnect
                        </b-button>
                      </div>
                    </b-card>

                    <!-- Error details if status is error -->
                    <b-alert v-if="plaidConnection.status === 'error'" variant="warning" show class="mb-3">
                      <strong>Connection Issue:</strong> {{ plaidConnection.error_message || 'Unknown error' }}
                      <br>
                      <small>Your bank may require you to re-authenticate. Click "Reconnect" to fix this.</small>
                      <br>
                      <b-button variant="warning" size="sm" class="mt-2" @click="reconnectPlaid">
                        <i class="fa fa-refresh mr-1"></i> Reconnect
                      </b-button>
                    </b-alert>

                    <!-- Sync Controls -->
                    <b-card class="border-1 mb-4">
                      <h6 class="mb-3">Transaction Sync</h6>
                      <b-button variant="outline-primary" @click="syncPlaidTransactions" :disabled="plaidLoading">
                        <b-spinner v-if="plaidLoading" small class="mr-1"></b-spinner>
                        <i v-else class="fa fa-refresh mr-1"></i>
                        Sync Now
                      </b-button>
                      <small class="text-muted ml-3">
                        Transactions are synced automatically. Use this button for manual testing.
                      </small>

                      <!-- Sync Result -->
                      <div v-if="plaidSyncResult" class="mt-3">
                        <b-alert variant="info" show>
                          <strong>Sync Result:</strong>
                          {{ plaidSyncResult.added_count }} added,
                          {{ plaidSyncResult.modified_count }} modified,
                          {{ plaidSyncResult.removed_count }} removed
                        </b-alert>
                      </div>
                    </b-card>
                  </div>

                </div>
              </b-tab>
           <!-- BANK CONNECTION (PLAID) TAB END -->

              </b-tabs>
        </section>
        <!-- TAB PANEL END -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import vSelect from 'vue-select'
import { mapState, mapActions, mapMutations } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import CommonOverlay from "@/components/CommonOverlay";
import EmailReportsTab from "./components/EmailReports/EmailReportsTab.vue";
import EmailSettingsTab from "./components/EmailSettings/EmailSettingsTab.vue";
import PaymentSettings from "./components/PaymentSettings/PaymentSettings.vue";
import DemoUnavailable from "@/components/Demo/DemoUnavailable.vue";
import _ from 'lodash';
import mixin from '../../mixin.js';
import { splitResponsibleEmployeeIds } from '@/utils/permissions';
import { extractApiError } from '@/utils/apiError';
import { resolveDismissScope } from '@/utils/actionCenterReadState';

export default {
  name: "Settings",
  components: {
    DemoUnavailable,
    Multiselect,
    draggable,
    ErrorDisplay,
    CommonOverlay,
    vSelect,
    EmailReportsTab,
    EmailSettingsTab,
    PaymentSettings
  },
  mixins: [mixin],

  async beforeMount() {
    await this.init();
    this.loadPlaidLink();
  },

  data() {
    return {
      saving: false,
      results: [],
      _settings: null,  // converted from Settings object to make it easy to load settings on the page
      // General settings
      timeZone:['Africa/Maseru', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/New_York', 'America/Phoenix'],
      selectedTz: '',
      // Overdue Recall variables
      orMaxNumberOfFollowups: '',
      orSelectedFollowupFrequency: '1',
      orAllowOverRide:'',
      orSelectedWikiPages: [],
      orAccountablePerson: [],
      orDefaultProvider: [],
      orCopyToCommLog: '',
      orAutoFrequencyDurationType: '',
      orAutoFrequencyDuration: '',
      orStatusAppointmentScheduled:[],
      orStatusRequireFollowUp:[],
      orStatusDontFollowUp:[],
      /* Reason for creating extra 3 variables is to store the original values when the page loaded so that if something is removed, I can detect that and delete on sql side later */
      orOrigStatusAppointmentScheduled:[],
      orOrigStatusRequireFollowUp:[],
      orOrigStatusDontFollowUp:[],
      orCustomFollowUps: [],
      orDailyCalls:'',
      orWeeklyCalls:'',
      orMonthlyCalls:'',
      orShowAddForm: undefined,
      orOpenDentalStatuses: [],

      // Unscheduled Treatment variables
      utCustomCodes: [],      
      utSelectedCustomCategoriesForInclude: [],
      utSelectedCustomCategoriesForExclude: [],
      utMaxNumberOfFollowups: '',
      utSelectedFollowupFrequency: '1',
      utAllowOverRide:'',
      utSelectedWikiPages: [],
      utSelectedIncludeCodes: [],
      utSelectedExcludeCodes: [],
      // Zero-fee rescue. Off unless the office opts in; utZeroFeeCodes holds full procCode
      // objects for the multiselect but is persisted as pipe-joined bare codes.
      utShowZeroFeeCodes: false,
      utZeroFeeCodes: [],
      utAccountablePerson: [],
      utDefaultProvider: [],
      utCopyToCommLog: '',
      utAutoFrequencyDurationType: '',
      utAutoFrequencyDuration: '',
      utStatusAppointmentScheduled:[],
      utStatusRequireFollowUp:[],
      utStatusDontFollowUp:[],
      utCustomFollowUps: [],
      utDailyCalls:'',
      utWeeklyCalls:'',
      utMonthlyCalls:'',
      utOpenDentalStatuses: [],

      // outstanding claims
      ocAccountablePerson: [],
      ocFollowupDuration: '',
      ocFollowupDurationType: '',
      ocStatusClaimProcessed:[],
      ocStatusRequireFollowUp:[],
      ocStatusDontFollowUp:[],
      ocCopyToCommLog: '',
      ocCopyToStatusHistory: '',
      ocSelectedWikiPages: [],
      ocOpenDentalStatuses: [],

      // outstanding pre-auth
      opAccountablePerson: [],
      opStatusClaimProcessed:[],
      opStatusRequireFollowUp:[],
      opStatusDontFollowUp:[],
      opCopyToCommLog: '',
      opCopyToStatusHistory: '',
      opSelectedWikiPages: [],
      opOpenDentalStatuses: [],

      // processed pre-auth
      ppAccountablePerson: [],
      ppStatusAppointmentScheduled:[],
      ppStatusRequireFollowUp:[],
      ppStatusDontFollowUp:[],
      ppCopyToCommLog: '',
      ppSelectedWikiPages: [],
      ppOpenDentalStatuses: [],
      ppMaxNumberOfFollowups: '',
      ppSelectedFollowupFrequency: '',
      ppAutoFrequencyDuration: '',
      ppAutoFrequencyDurationType: '',
      ppSelectedFollowupFrequency: '',
      ppAllowOverRide: '',
      ppCustomFollowUps: [],

      // patient balances
      pbAccountablePerson: [],
      pbStatusAppointmentScheduled:[],
      pbStatusRequireFollowUp:[],
      pbStatusDontFollowUp:[],
      pbCopyToCommLog: 'TRUE',
      pbSelectedWikiPages: [],
      pbOpenDentalStatuses: [],
      pbOpenDentalStatusesDefault: [
        {ODDefNum: -1, ClientSystemFollowupStatus : 'Bad Debt - Do Not Call'}, 
        {ODDefNum: -2, ClientSystemFollowupStatus : 'Bad Debt - Sent to Collections'}, 
        {ODDefNum: -3, ClientSystemFollowupStatus : 'Not Home. Call Again'}, 
        {ODDefNum: -4, ClientSystemFollowupStatus : 'Left Message with Fam'}, 
        {ODDefNum: -5, ClientSystemFollowupStatus : 'Left Voicemail'}, 
        {ODDefNum: -6, ClientSystemFollowupStatus : 'Pt on a pymt plan'}, 
        {ODDefNum: -7, ClientSystemFollowupStatus : 'Pt makes installment pymts'},
        {ODDefNum: -8, ClientSystemFollowupStatus : 'Paid in Full'}
        ],
      pbShowAddForm: false,

      
      // Broken Appointment variables
      baAccountablePerson: [],
      baMaxNumberOfFollowups: '',
      baSelectedFollowupFrequency: '1',
      baAllowOverRide:'',
      baSelectedWikiPages: [],      
      baCopyToCommLog: '',
      baAutoFrequencyDurationType: '',
      baAutoFrequencyDuration: '',
      baStatusAppointmentScheduled:[],
      baStatusRequireFollowUp:[],
      baStatusDontFollowUp:[],
      baCustomFollowUps: [],
      
      baDailyCalls:'',
      baWeeklyCalls:'',
      baMonthlyCalls:'',
      baShowAddFbam: undefined,
      baOpenDentalStatuses: [],
      baAdjustSelectedValues: [],


        showHelpButton: false,
        followupNoteToCommLog: false,

        // Patient profile photo → OD imaging category. '' means "Auto", i.e. let
        // the backend resolve Patient Pictures itself; a DefNum string overrides it.
        patientPhotoImagingCategory: '',
        patientPhotoCategories: [],

        // Action Center: 'office' clears an alert for everyone (default), 'individual' just for me.
        actionCenterDismissScope: 'office',

      // Slack Integration
      slackLoading: false,
      slackError: null,
      slackConnected: false,
      slackWorkspaceName: '',
      slackChannels: [],
      slackTestChannel: null,
      slackTestMessage: '',

      // Mango Voice Integration
      mangoVoiceLoading: false,
      mangoVoiceError: null,
      mangoVoiceToken: '',
      mangoVoiceTokenVisible: false,

      // Plaid Bank Connection
      plaidLoading: false,
      plaidError: null,
      plaidConnection: null,
      plaidSyncResult: null,

      yesNoOptions:[
        {text:'Yes', value: 'TRUE'},
        {text:'No', value: 'FALSE'}
      ],
      wikiPages: [],
      text: "",
      newTask:'',
      temp: [],
      
    };
  },

  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setErrored', 'setMessage']),
    ...mapActions('customer', ['getEmployees', 'getStatuses', 'getSettings', 'saveSettings', 'upsertSettings', 'getProcCodes']),
    ...mapActions('wiki', ['getWikiPages']),
    ...mapActions('teamio', ['runQuery']),
    ...mapActions('slack', {
      slackGetInstallUrl: 'getInstallUrl',
      slackGetStatus: 'getSlackStatus',
      slackGetChannels: 'getChannels',
      slackSendMessage: 'sendMessage',
      slackDisconnect: 'disconnect'
    }),
    ...mapActions('plaid', {
      plaidGetLinkToken: 'getLinkToken',
      plaidGetUpdateLinkToken: 'getUpdateLinkToken',
      plaidExchangeToken: 'exchangeToken',
      plaidGetStatus: 'getStatus',
      plaidDisconnect: 'disconnect',
      plaidSyncTransactions: 'syncTransactions'
    }),
    ...mapMutations('teamio', ['emptyResults']),
    ...mapMutations('customer', ['setSettings']),

    async init() {
      await this.getStatuses(this.siteID);
      await this.getSettings({siteID: this.siteID});

      if(this.employees && this.employees.length === 0)
        await this.getEmployees({siteID: this.siteID});
      if(this.wikiPages && this.wikiPages.length === 0)
        this.wikiPages = await this.getWikiPages({siteID: this.siteID});

      await this.getProcCodes({siteID: this.siteID});

      this.emptyResults();

      let query = {
        type: 'CLIENT_STATUSES',
        siteID: this.siteID
      };

      let temp = await this.runQuery(query);
      this.orOpenDentalStatuses = _.cloneDeep(temp.data[0]);
      this.utOpenDentalStatuses = _.cloneDeep(temp.data[0]);
      this.ocOpenDentalStatuses = _.cloneDeep(temp.data[1]);
      this.opOpenDentalStatuses = _.cloneDeep(temp.data[1]);
      this.ppOpenDentalStatuses = _.cloneDeep(temp.data[0]);

      let allPbStatuses = temp.data[2] && temp.data[2].length > 0 ? _.union(temp.data[2],this.pbOpenDentalStatusesDefault) : this.pbOpenDentalStatusesDefault;
      let uniqPbStatuses = _.uniqBy(allPbStatuses, 'ODDefNum');
      this.pbOpenDentalStatuses = uniqPbStatuses;
      this.baOpenDentalStatuses = _.cloneDeep(temp.data[0]);

      this.emptyResults();

      /*
      let query2 = {
        type: 'SETTINGS_BROKEN_APPOINTMENT',
        siteID: this.siteID
      };

      let temp2 = await this.runQuery(query2);
      */

      this._settings = _.keyBy(this.settings, 'Property');
      //console.dir(this._settings);
      this.loadODSettings();
      this.loadUTSettings();
        this.loadAgingSettings();
        this.loadBaSettings();
        // Task settings now loaded inside TaskSettings.vue (gear icon on /app/todo)
        this.loadGeneralSettings();
        this.loadSlackStatus();
        this.loadMangoVoiceSettings();
      //console.log('All settings loaded');

      //this.emptyResults();

      
      let empArr = [];
      empArr.push();

      // Now get all the lists for employees
      let employeesToGetListFor = [];

      // Each *_RESPONSIBLE_EMPLOYEEID PropertyValue is pipe-delimited
      // ("empA|empB|empC"). Previously this code pushed the whole string
      // as a single ID, so the resulting `IN (...)` SQL filter never
      // matched anything on multi-employee sites. Split and dedupe so the
      // EMPLOYEE_LISTS backend query gets a flat array of EmployeeIDs.
      const RESPONSIBLE_SETTINGS = [
        'OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID',
        'UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID',
        'OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID',
        'OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID',
        'PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID',
        'PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID',
        'BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID',
      ];
      const seen = new Set();
      for (const key of RESPONSIBLE_SETTINGS) {
        if (!this._settings || !this._settings[key]) continue;
        for (const id of splitResponsibleEmployeeIds(this._settings[key].PropertyValue)) {
          if (!seen.has(id)) {
            seen.add(id);
            employeesToGetListFor.push(id);
          }
        }
      }

      if(employeesToGetListFor.length > 0) {
        let query3 = {
          type: 'EMPLOYEE_LISTS',
          employees: employeesToGetListFor
        };
        let temp3 = await this.runQuery(query3);
      }           
    },

    codeWithDesc({ ProcCode, Descript }){
      return `${ProcCode} — [${Descript}]`;
    },

    addUtCustomCode() {
      let obj = {
        procCodes: [],
        categoryName: ''
      }

      this.utCustomCodes.push(obj);
    },

    removeUtCustomCode(index) {
      if(this.utCustomCodes.length > 0)
        this.utCustomCodes.splice(index,1);
    },

    getProcCodesForCustomCategory(cat) {
      if(this.utCustomCodes) {
        let temp = this.utCustomCodes.filter((a) => a.categoryName === cat);
        if(temp.length > 0)
          return temp[0].procCodes;
        else
          return [];
      }
    },

    removeCode(item, option) {
      let removeIdx = item.procCodes.findIndex(each => {
        return each.ProcCode === option.ProcCode;
      });
      item.procCodes.splice(removeIdx, 1);
    },

    removeCodeInclude(option) {
      let removeIdx = this.utSelectedIncludeCodes.findIndex(each => {
        return each.ProcCode === option.ProcCode;
      });
      this.utSelectedIncludeCodes.splice(removeIdx, 1);
    },

    removeZeroFeeCode(option) {
      let removeIdx = this.utZeroFeeCodes.findIndex(each => {
        return each.ProcCode === option.ProcCode;
      });
      this.utZeroFeeCodes.splice(removeIdx, 1);
    },

    removeCodeExclude(option) {
      let removeIdx = this.utSelectedExcludeCodes.findIndex(each => {
        return each.ProcCode === option.ProcCode;
      });
      this.utSelectedExcludeCodes.splice(removeIdx, 1);
    },

    removeIncludeCustomTag(option) {
      //console.log("remove include custom tag called");
      let procCodesToRemove = this.getProcCodesForCustomCategory(option);
      let orig = this.utSelectedIncludeCodes;
      for(let code of procCodesToRemove) {
        orig = orig.filter(item => item.ProcCode !== code.ProcCode && item.Descript !== code.Descript);
      }
      this.$set(this, 'utSelectedIncludeCodes', orig);

      let removeIdx = this.utSelectedCustomCategoriesForInclude.indexOf(option);
      this.utSelectedCustomCategoriesForInclude.splice(removeIdx,1);
    },

    removeExcludeCustomTag(option) {
      //console.log("remove exclude custom tag called");
      let procCodesToRemove = this.getProcCodesForCustomCategory(option);
      let orig = this.utSelectedExcludeCodes;
      for(let code of procCodesToRemove) {
        orig = orig.filter(item => item.ProcCode !== code.ProcCode && item.Descript !== code.Descript);
      }
      this.$set(this, 'utSelectedExcludeCodes', orig);

      let removeIdx = this.utSelectedCustomCategoriesForExclude.indexOf(option);
      this.utSelectedCustomCategoriesForExclude.splice(removeIdx,1);
    },

    providerCustomLabel({FName, MI, LName, Suffix, Abbr}) {
      return `${FName} ${MI} ${LName} ${Suffix} (${Abbr})`;
    },

    onORFollowupNoChange() {
      //console.log(`onORFollowupNoChange called`);
      this.orCustomFollowUps = [];
      if(this.orSelectedFollowupFrequency === "2") {
        this.orAutoFrequencyDuration = '';
        this.orAutoFrequencyDurationType = '';
        if(this.orMaxNumberOfFollowups>1) {
          for(let i = 1; i < this.orMaxNumberOfFollowups; i++) {
            let temp = 'OVERDUE_RECALL_FOLLOWUP_' + i;
            this.orCustomFollowUps.push({
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'days'
            })
          }
        }
        
        else {
          this.orCustomFollowUps=[{
            durationType: 'days',
            duration: 1
          }]
        }
      }
    },

    onUTFollowupNoChange() {
      //console.log(`onUTFollowupNoChange called`);
      this.utCustomFollowUps = [];
      if(this.utSelectedFollowupFrequency === "2") {
        this.utAutoFrequencyDuration = '';
        this.utAutoFrequencyDurationType = '';
        if(this.utMaxNumberOfFollowups>1){
          for(let i = 1; i < this.utMaxNumberOfFollowups; i++){
            let temp = 'UNSCHEDULED_TREATMENT_FOLLOWUP_' + i;
            this.utCustomFollowUps.push({
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'days'
            })
          }
        }
        else {
          this.utCustomFollowUps=[{
            durationType: 'days',
            duration: 1
          }]
        }
      } 
    },

    /*
    onBAFollowupNoChange() {
      console.log(`onBAFollowupNoChange called`);
      this.baCustomFollowUps = [];

      if(this.baSelectedFollowupFrequency === "2") {
        this.baAutoFrequencyDuration = '';
        this.baAutoFrequencyDurationType = '';
      }      
      
      if(this.baCustomFollowUps.length === 0) {
        if(this.baMaxNumberOfFollowups>1 && parseInt(this.baSelectedFollowupFrequency,10) === 2){
          for(let i = 1; i < this.baMaxNumberOfFollowups; i++){
            let temp = 'BROKEN_APPOINTMENT_FOLLOWUP_' + i;
            //console.log(`temp:${temp}`);
            let o = {
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'days'
            };
            //console.log(o);
            this.baCustomFollowUps.push(o);
          }
        }
        
        else {
          this.baCustomFollowUps=[{
            durationType: 'days',
            duration: 1
          }]
        }
      }
    },
    */

    onBAFollowupNoChange() {
      //console.log(`onBAFollowupNoChange called`);      
      this.baCustomFollowUps = [];

      if(this.baSelectedFollowupFrequency === "2") {
        this.baAutoFrequencyDuration = '';
        this.baAutoFrequencyDurationType = '';
        if(this.baMaxNumberOfFollowups>1) {
          for(let i = 1; i < this.baMaxNumberOfFollowups; i++){
            let temp = 'BROKEN_APPOINTMENTS_FOLLOWUP_' + i;
            //console.log(`temp:${temp}`);
            let o = {
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'days'
            };
            //console.log(o);
            this.baCustomFollowUps.push(o);            
          }          
        } else {
          this.baCustomFollowUps=[{
            durationType: 'days',
            duration: 1
          }]
        }
      }
    },

    onPPFollowupNoChange() {
      // console.log(`onPPFollowupNoChange called`);
      if(this.ppSelectedFollowupFrequency === "2") {
        this.ppAutoFrequencyDuration = '';
        this.ppAutoFrequencyDurationType = '';
      }
      //this.ppCustomFollowUps = [];
      if(this.ppCustomFollowUps.length === 0) {
        if(this.ppMaxNumberOfFollowups>1 && parseInt(this.ppSelectedFollowupFrequency,10) === 2){
          for(let i = 1; i < this.ppMaxNumberOfFollowups; i++){
            let temp = 'PROCESSED_PREAUTHS_FOLLOWUP_' + i;
            this.ppCustomFollowUps.push({
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'days'
            })
          }
        }
        
        else {
          this.ppCustomFollowUps=[{
            durationType: 'days',
            duration: 1
          }]
        }
      }
    },

    addFollouwup(){
      if(parseInt(this.orSelectedFollowupFrequency) === 2){
        this.orCustomFollowUps.push({
          durationType: 'days',
          duration: 1
        })
      }
    },

    addUTFollouwup(){
      if(parseInt(this.utSelectedFollowupFrequency) === 2){
        this.utCustomFollowUps.push({
          durationType: 'days',
          duration: 1
        })
      }
    },

    addBAFollouwup(){
      if(parseInt(this.baSelectedFollowupFrequency) === 2) {
        this.baCustomFollowUps.push({
          durationType: 'days',
          duration: 1
        })
      }
    },

    removeFollowup(index){
      // console.log(index);
      if(this.orCustomFollowUps.length > 1){
        this.orCustomFollowUps.splice(index,1);
      }
    },

    removePPFollowup(index){
      // console.log(index);
      if(this.ppCustomFollowUps.length > 1){
        this.ppCustomFollowUps.splice(index,1);
      }
    },

    removeUTFollowup(index){
      // console.log(index);
      if(this.utCustomFollowUps.length > 1){
        this.utCustomFollowUps.splice(index,1);
      }
    },

    removeBAFollowup(index){
      // console.log(index);
      if(this.baCustomFollowUps.length > 1){
        this.baCustomFollowUps.splice(index,1);
      }
    },

    addNewTask(){
      /* First union all 4 arrays and then find the highest ODDefNum available in pbOpenDentalStatuses 
          by getting the MIN because they're negative
      */
      let allPbStatuses = _.union(this.pbOpenDentalStatuses, this.pbStatusAppointmentScheduled, this.pbStatusRequireFollowUp, this.pbStatusDontFollowUp);
      let pbMaxODDefNum = _.minBy(allPbStatuses, 'ODDefNum');
      let nextODDefNum = parseInt(pbMaxODDefNum.ODDefNum,10) - 1;
      if(this.newTask.trim().length){
        let status = {
          ODDefNum: nextODDefNum,
          ClientSystemFollowupStatus : this.newTask.trim()
        };
      
        this.pbOpenDentalStatuses.push(status);
        this.newTask = '';
        this.pbShowAddForm=false;
      }
    },
    cancelTask(){
      this.newTask = '';
      this.pbShowAddForm=false;
    },
    removeTask(index){
      this.orOpenDentalStatuses.splice(index,1);
    },


    loadGeneralSettings() {
      this.selectedTz = this._settings.GENERAL_TIMEZONE ? this._settings.GENERAL_TIMEZONE.PropertyValue : '';
    },

    async saveTimezoneSettings() {
      // Use upsertSettings for GENERAL settings - it safely updates without bulk delete
      let gSettings = {
        GENERAL_TIMEZONE : this.selectedTz
      }

      let payload = {
        settings: gSettings,
        siteID: this.siteID,
      };

      //console.log('Payload:' + JSON.stringify(payload));

      try {
        this.saving = true;
        await this.upsertSettings(payload);
        await this.init();
        this.$toast.success("Settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    loadGeneralSettings() {
      // Show help button only if explicitly set to TRUE, default is false (hidden)
      this.showHelpButton = this._settings.GENERAL_SHOW_HELP_BUTTON ? this._settings.GENERAL_SHOW_HELP_BUTTON.PropertyValue === 'TRUE' : false;
      // Copy follow-up Optional Note to OD Comm Log only if explicitly TRUE, default is false (off)
      this.followupNoteToCommLog = this._settings.GENERAL_FOLLOWUP_NOTE_COPY_TO_COMMLOG ? this._settings.GENERAL_FOLLOWUP_NOTE_COPY_TO_COMMLOG.PropertyValue === 'TRUE' : false;
      // Patient profile photo destination. Absent/'' = Auto (backend resolves Patient Pictures).
      this.patientPhotoImagingCategory = this._settings.PATIENT_PHOTO_IMAGING_CATEGORY ? String(this._settings.PATIENT_PHOTO_IMAGING_CATEGORY.PropertyValue || '') : '';
      // Action Center clearing scope. Absent / unknown = 'office' — the same rule the panel applies.
      this.actionCenterDismissScope = resolveDismissScope(this._settings.ACTION_CENTER_DISMISS_SCOPE && this._settings.ACTION_CENTER_DISMISS_SCOPE.PropertyValue);
      // Fire-and-forget: the dropdown is optional and the page must not wait on OD.
      if (this.patientProfilePhotoEnabled) this.loadPatientPhotoCategories();
    },

    /**
     * OD imaging categories for the patient-photo destination dropdown. Same
     * endpoint the form builder and ConversationsSettings use — rows of
     * { DefNum, ItemName } out of the site's local OD `definition` table.
     *
     * Only console.warns on failure: this is one optional dropdown on a tab full
     * of unrelated settings, and a site whose exe is offline should still be able
     * to save its timezone.
     */
    async loadPatientPhotoCategories() {
      if (this.patientPhotoCategories.length) return;
      try {
        const r = await this.$store.dispatch('forms/getFormCategories', { siteID: this.siteID });
        this.patientPhotoCategories = Array.isArray(r) ? r : (r && r.data) || [];
      } catch (e) {
        console.warn('Settings: failed to load OD imaging categories for patient photos:', e);
      }
    },

    async saveGeneralSettings() {
      let generalSettings = {
        GENERAL_SHOW_HELP_BUTTON: this.showHelpButton ? 'TRUE' : 'FALSE',
        GENERAL_FOLLOWUP_NOTE_COPY_TO_COMMLOG: this.followupNoteToCommLog ? 'TRUE' : 'FALSE',
        PATIENT_PHOTO_IMAGING_CATEGORY: this.patientPhotoImagingCategory || ''
      }
      // Only admins see the control, so only admins write it — a Manager saving this tab must not touch it.
      if (this.canEditActionCenterScope) {
        generalSettings.ACTION_CENTER_DISMISS_SCOPE = resolveDismissScope(this.actionCenterDismissScope);
      }

      // Use upsertSettings for GENERAL settings - it safely updates without bulk delete
      let payload = {
        settings: generalSettings,
        siteID: this.siteID,
      };

      try {
        this.saving = true;
        await this.upsertSettings(payload);
        await this.init();
        this.$toast.success("General settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    // ========== SLACK INTEGRATION METHODS ==========
    
    async loadSlackStatus() {
      try {
        this.slackLoading = true;
        this.slackError = null;
        
        // Check for OAuth return parameters in URL
        const urlParams = new URLSearchParams(window.location.search);
        const slackStatus = urlParams.get('slack');
        const workspace = urlParams.get('workspace');
        
        if (slackStatus === 'connected') {
          this.$toast.success(`Successfully connected to Slack workspace: ${workspace || 'Unknown'}`);
          // Clean up URL params
          const url = new URL(window.location);
          url.searchParams.delete('slack');
          url.searchParams.delete('workspace');
          window.history.replaceState({}, document.title, url.pathname + url.hash);
        } else if (slackStatus === 'cancelled') {
          this.$toast.warning('Slack connection was cancelled');
          const url = new URL(window.location);
          url.searchParams.delete('slack');
          window.history.replaceState({}, document.title, url.pathname + url.hash);
        } else if (slackStatus === 'error') {
          const message = urlParams.get('message');
          this.$toast.error(`Slack connection failed: ${message || 'Unknown error'}`);
          const url = new URL(window.location);
          url.searchParams.delete('slack');
          url.searchParams.delete('message');
          window.history.replaceState({}, document.title, url.pathname + url.hash);
        }
        
        const response = await this.slackGetStatus({ siteID: this.siteID });
        this.slackConnected = response.connected;
        this.slackWorkspaceName = response.workspaceName || '';
        
        if (this.slackConnected) {
          await this.refreshSlackChannels();
        }
      } catch (err) {
        console.error('Error loading Slack status:', err);
        this.slackError = 'Failed to load Slack status';
      } finally {
        this.slackLoading = false;
      }
    },

    async connectSlack(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      try {
        this.slackLoading = true;
        this.slackError = null;
        
        // Include only the origin as returnUrl (backend appends /app/settings)
        const returnUrl = window.location.origin;
        const response = await this.slackGetInstallUrl({ siteID: this.siteID, returnUrl });
        
        if (response.installUrl) {
          // Redirect the main window to Slack OAuth (not a popup)
          // This provides better UX - user completes OAuth and comes back to this page
          window.location.href = response.installUrl;
        }
      } catch (err) {
        console.error('Error connecting to Slack:', err);
        this.slackError = 'Failed to start Slack connection';
        this.slackLoading = false;
      }
      return false;
    },

    async refreshSlackChannels(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      try {
        this.slackLoading = true;
        this.slackError = null;
        
        // First refresh the status
        const statusResponse = await this.slackGetStatus({ siteID: this.siteID });
        this.slackConnected = statusResponse.connected;
        this.slackWorkspaceName = statusResponse.workspaceName || '';
        
        if (this.slackConnected) {
          const channelsResponse = await this.slackGetChannels({ siteID: this.siteID });
          this.slackChannels = channelsResponse.channels || [];
        }
      } catch (err) {
        console.error('Error refreshing Slack channels:', err);
        this.slackError = 'Failed to refresh channels';
      } finally {
        this.slackLoading = false;
      }
      return false;
    },

    async disconnectSlack() {
      if (!confirm('Are you sure you want to disconnect Slack? This will remove the integration and you will need to reconnect to use Slack in workflows.')) {
        return;
      }
      
      try {
        this.slackLoading = true;
        this.slackError = null;
        await this.slackDisconnect({ siteID: this.siteID });
        
        this.slackConnected = false;
        this.slackWorkspaceName = '';
        this.slackChannels = [];
        this.slackTestChannel = null;
        this.slackTestMessage = '';
        
        this.$toast.success('Slack disconnected successfully');
      } catch (err) {
        console.error('Error disconnecting Slack:', err);
        this.slackError = 'Failed to disconnect Slack';
      } finally {
        this.slackLoading = false;
      }
    },

    async sendTestSlackMessage(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      if (!this.slackTestChannel || !this.slackTestMessage) {
        this.$toast.warning('Please select a channel and enter a message');
        return false;
      }
      
      try {
        this.slackLoading = true;
        this.slackError = null;
        await this.slackSendMessage({
          siteID: this.siteID,
          channelId: this.slackTestChannel,
          message: this.slackTestMessage
        });
        
        this.$toast.success('Test message sent successfully!');
        this.slackTestMessage = '';
      } catch (err) {
        console.error('Error sending test message:', err);
        this.slackError = extractApiError(err, 'Failed to send test message. Make sure to invite the Teamio bot to the channel.');
        this.$toast.error(this.slackError);
      } finally {
        this.slackLoading = false;
      }
      return false;
    },

    // ========== END SLACK INTEGRATION METHODS ==========

    // ========== MANGO VOICE INTEGRATION METHODS ==========

    async loadMangoVoiceSettings() {
      try {
        this.mangoVoiceLoading = true;
        this.mangoVoiceError = null;

        // Load token from settings (already loaded in _settings)
        if (this._settings && this._settings.MANGO_VOICE_SECURITY_TOKEN) {
          this.mangoVoiceToken = this._settings.MANGO_VOICE_SECURITY_TOKEN.PropertyValue || '';
        } else {
          this.mangoVoiceToken = '';
        }
      } catch (err) {
        console.error('Error loading Mango Voice settings:', err);
        this.mangoVoiceError = 'Failed to load Mango Voice settings';
      } finally {
        this.mangoVoiceLoading = false;
      }
    },

    generateRandomToken() {
      // Generate a secure random token (32 characters, alphanumeric)
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let token = '';
      const array = new Uint32Array(32);
      window.crypto.getRandomValues(array);
      for (let i = 0; i < 32; i++) {
        token += chars[array[i] % chars.length];
      }
      return token;
    },

    async generateMangoVoiceToken() {
      try {
        this.mangoVoiceLoading = true;
        this.mangoVoiceError = null;

        const newToken = this.generateRandomToken();

        // Save to settings
        const payload = {
          settings: {
            MANGO_VOICE_SECURITY_TOKEN: newToken
          },
          siteID: this.siteID,
        };

        await this.upsertSettings(payload);

        this.mangoVoiceToken = newToken;
        this.mangoVoiceTokenVisible = true; // Show the token so user can copy it

        this.$toast.success('Security token generated successfully!');
      } catch (err) {
        console.error('Error generating Mango Voice token:', err);
        this.mangoVoiceError = 'Failed to generate security token';
        this.$toast.error(this.mangoVoiceError);
      } finally {
        this.mangoVoiceLoading = false;
      }
    },

    async regenerateMangoVoiceToken() {
      if (!confirm('Are you sure you want to regenerate the security token? The current token will stop working immediately, and you will need to update the webhook URL in Mango Voice.')) {
        return;
      }

      await this.generateMangoVoiceToken();
    },

    copyToClipboard(text, label) {
      navigator.clipboard.writeText(text).then(() => {
        this.$toast.success(`${label} copied to clipboard!`);
      }).catch(err => {
        console.error('Failed to copy:', err);
        this.$toast.error('Failed to copy to clipboard');
      });
    },

    // ========== END MANGO VOICE INTEGRATION METHODS ==========

    // ─── Plaid Bank Connection ──────────────────────────────────
    loadPlaidLink() {
      if (document.getElementById('plaid-link-script')) return;
      const script = document.createElement('script');
      script.id = 'plaid-link-script';
      script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
      script.async = true;
      document.head.appendChild(script);
    },

    async loadPlaidStatus() {
      try {
        this.plaidLoading = true;
        this.plaidError = null;
        const result = await this.plaidGetStatus({ siteID: this.siteID });
        this.plaidConnection = result;
      } catch (err) {
        this.plaidError = extractApiError(err);
      } finally {
        this.plaidLoading = false;
      }
    },

    async connectPlaid() {
      try {
        this.plaidLoading = true;
        this.plaidError = null;

        // Get link token from our backend
        const tokenResult = await this.plaidGetLinkToken({ siteID: this.siteID });

        // Open Plaid Link
        const handler = window.Plaid.create({
          token: tokenResult.link_token,
          onSuccess: async (public_token, metadata) => {
            try {
              const account = metadata.accounts?.[0] || {};
              await this.plaidExchangeToken({
                siteID: this.siteID,
                public_token,
                account: {
                  id: account.id,
                  name: account.name,
                  mask: account.mask,
                  type: account.type,
                  subtype: account.subtype
                }
              });
              this.$toast.success('Bank account connected successfully!');
              await this.loadPlaidStatus();
            } catch (err) {
              this.plaidError = extractApiError(err);
              this.$toast.error('Failed to connect bank account');
            } finally {
              this.plaidLoading = false;
            }
          },
          onExit: (err) => {
            this.plaidLoading = false;
            if (err) {
              console.log('Plaid Link exit with error:', err);
            }
          }
        });

        handler.open();
      } catch (err) {
        this.plaidLoading = false;
        this.plaidError = extractApiError(err);
        this.$toast.error('Failed to start bank connection');
      }
    },

    async reconnectPlaid() {
      // Update mode: reuses the existing Plaid item via its access_token, so no
      // exchangeToken call is needed on success. A fresh sync clears the error
      // status (sync.js sets status='active' + clears error_code/error_message
      // on a successful /transactions/sync).
      try {
        this.plaidLoading = true;
        this.plaidError = null;

        const tokenResult = await this.plaidGetUpdateLinkToken({ siteID: this.siteID });

        const handler = window.Plaid.create({
          token: tokenResult.link_token,
          onSuccess: async () => {
            try {
              await this.plaidSyncTransactions({ siteID: this.siteID });
              this.$toast.success('Bank account reconnected!');
              await this.loadPlaidStatus();
            } catch (err) {
              this.plaidError = extractApiError(err);
              this.$toast.error('Reconnect succeeded but sync failed — try Sync Now');
              await this.loadPlaidStatus();
            } finally {
              this.plaidLoading = false;
            }
          },
          onExit: (err) => {
            this.plaidLoading = false;
            if (err) {
              console.log('Plaid Link (update mode) exit with error:', err);
            }
          }
        });

        handler.open();
      } catch (err) {
        this.plaidLoading = false;
        this.plaidError = extractApiError(err);
        this.$toast.error('Failed to start reconnect flow');
      }
    },

    async disconnectPlaid() {
      if (!confirm('Are you sure you want to disconnect your bank account? Transaction history will be preserved.')) {
        return;
      }
      try {
        this.plaidLoading = true;
        this.plaidError = null;
        await this.plaidDisconnect({ siteID: this.siteID });
        this.plaidConnection = null;
        this.$toast.success('Bank account disconnected');
      } catch (err) {
        this.plaidError = extractApiError(err);
        this.$toast.error('Failed to disconnect bank account');
      } finally {
        this.plaidLoading = false;
      }
    },

    async syncPlaidTransactions() {
      try {
        this.plaidLoading = true;
        this.plaidError = null;
        this.plaidSyncResult = null;
        const result = await this.plaidSyncTransactions({ siteID: this.siteID });
        this.plaidSyncResult = result;
        this.$toast.success(
          `Sync complete: ${result.added_count} added, ${result.modified_count} modified, ${result.removed_count} removed`
        );
        await this.loadPlaidStatus();
      } catch (err) {
        this.plaidError = extractApiError(err);
        this.$toast.error('Failed to sync transactions');
      } finally {
        this.plaidLoading = false;
      }
    },

    // ========== END PLAID BANK CONNECTION METHODS ==========

    loadODSettings() {
      //this.orAccountablePerson= this._settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => e.EmployeeID === this._settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue) : '';
      this.orAccountablePerson= this._settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      if (this._settings.OVERDUE_RECALL_DEFAULT_PROVIDER && this._settings.OVERDUE_RECALL_DEFAULT_PROVIDER.PropertyValue) {
        const provNums = String(this._settings.OVERDUE_RECALL_DEFAULT_PROVIDER.PropertyValue).split('|').map(n => parseInt(n, 10)).filter(n => !isNaN(n) && n > 0);
        this.orDefaultProvider = this.uniqueProviders.filter(p => provNums.includes(p.ProvNum));
      } else {
        this.orDefaultProvider = [];
      }
      this.orDailyCalls = this._settings.OVERDUE_RECALL_DAILY_CALLS_GOAL ? this._settings.OVERDUE_RECALL_DAILY_CALLS_GOAL.PropertyValue : '';
      this.orWeeklyCalls = this._settings.OVERDUE_RECALL_WEEKLY_CALLS_GOAL ? this._settings.OVERDUE_RECALL_WEEKLY_CALLS_GOAL.PropertyValue : '';
      this.orMonthlyCalls = this._settings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL ? this._settings.OVERDUE_RECALL_MONTHLY_CALLS_GOAL.PropertyValue : '';
      this.orMaxNumberOfFollowups= this._settings.OVERDUE_RECALL_MAX_FOLLOWUPS ? parseInt(this._settings.OVERDUE_RECALL_MAX_FOLLOWUPS.PropertyValue) : '';
      
       
      if (this._settings.OVERDUE_RECALL_AUTO_FREQUENCY) {
        if (this._settings.OVERDUE_RECALL_AUTO_FREQUENCY.PropertyValue !== '') {
          this.orSelectedFollowupFrequency = "1";
          this.orAutoFrequencyDuration = this._settings.OVERDUE_RECALL_AUTO_FREQUENCY.PropertyValue.split(' ')[0];
          this.orAutoFrequencyDurationType = this._settings.OVERDUE_RECALL_AUTO_FREQUENCY.PropertyValue.split(' ')[1];
        }
        else {
          this.orSelectedFollowupFrequency = "2";
          this.orAutoFrequencyDuration = '';
          this.orAutoFrequencyDurationType = '';
        }
      }

      if(this._settings.OVERDUE_RECALL_CUSTOM_FREQUENCY) {
        if(this._settings.OVERDUE_RECALL_CUSTOM_FREQUENCY.PropertyValue === 'TRUE') {
          this.orSelectedFollowupFrequency = "2";
          // now load the custom frequency durations
          //let arr = [];
          this.orCustomFollowUps = [];
          for(var i=1; i<this.orMaxNumberOfFollowups; i++) {
            let temp = 'OVERDUE_RECALL_FOLLOWUP_' + i;
            let o = {
              duration: this._settings[temp].PropertyValue.split(' ')[0],
              durationType: this._settings[temp].PropertyValue.split(' ')[1]
            }
            //console.log(`Loading overdue recall custom followup object:${JSON.stringify(o)}`);
            //arr.push(o);
            this.orCustomFollowUps.push(o);
          }
          //this.orCustomFollowUps = arr;
          //console.log(`Finally, orCustomFollowups array looks like this now: ${JSON.stringify(this.orCustomFollowUps)}`);
        }
        else
          this.orSelectedFollowupFrequency = "1";
      }
      
      this.orAllowOverRide= this._settings.OVERDUE_RECALL_ALLOW_FOLLOWUP_OVERRIDE ? this._settings.OVERDUE_RECALL_ALLOW_FOLLOWUP_OVERRIDE.PropertyValue : '';
      this.orStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 1);
      this.orOrigStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 1);
      this.orStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 3);
      this.orOrigStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 3);
      this.orStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 6);
      this.orOrigStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 3 && s.TeamioFollowupStatusID === 6);
      let x = _.union(this.orStatusAppointmentScheduled, this.orStatusDontFollowUp, this.orStatusRequireFollowUp);
      this.orOpenDentalStatuses = _.differenceBy(this.orOpenDentalStatuses, x, 'ClientSystemFollowupStatus');
      this.orCopyToCommLog= this._settings.OVERDUE_RECALL_COPY_TO_COMMLOG ? this._settings.OVERDUE_RECALL_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.orSelectedWikiPages= this._settings.OVERDUE_RECALL_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.OVERDUE_RECALL_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];
    },

    async saveODSettings() {
      //console.log('saving Overdue Recall settings');
      if(this.orStatusAppointmentScheduled.length > 1) {
        this.$toast.error('You can not have more than one Statuses for Appointment Scheduled');        
        return false;
      }
      let odSettings = {
        OVERDUE_RECALL_UNLIMITED_FOLLOWUPS: this.orMaxNumberOfFollowups ? 'FALSE' : 'TRUE',
        //OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID: this.orAccountablePerson ? this.orAccountablePerson.EmployeeID : '',
        OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID: this.orAccountablePerson ? _.map(this.orAccountablePerson, 'EmployeeID').join('|') : '',
        OVERDUE_RECALL_DEFAULT_PROVIDER: this.orDefaultProvider && this.orDefaultProvider.length > 0 ? this.orDefaultProvider.map(p => p.ProvNum).join('|') : '',
        OVERDUE_RECALL_DAILY_CALLS_GOAL: this.orDailyCalls,
        OVERDUE_RECALL_WEEKLY_CALLS_GOAL: this.orWeeklyCalls,
        OVERDUE_RECALL_MONTHLY_CALLS_GOAL: this.orMonthlyCalls,
        OVERDUE_RECALL_ALLOW_FOLLOWUP_OVERRIDE: this.orAllowOverRide,
        OVERDUE_RECALL_MAX_FOLLOWUPS: this.orMaxNumberOfFollowups,
        OVERDUE_RECALL_COPY_TO_COMMLOG: this.orCopyToCommLog ? this.orCopyToCommLog : 'FALSE'
      };
      
      if(parseInt(this.orSelectedFollowupFrequency,10) === 1) {
        odSettings.OVERDUE_RECALL_AUTO_FREQUENCY = this.orAutoFrequencyDuration + ' ' + this.orAutoFrequencyDurationType;
      }

      if(parseInt(this.orSelectedFollowupFrequency,10) === 2) {
        odSettings.OVERDUE_RECALL_CUSTOM_FREQUENCY = 'TRUE';
        let counter = 1;
        this.orCustomFollowUps.forEach(function(f) {
          let i = 'OVERDUE_RECALL_FOLLOWUP_' + counter;
          odSettings[i] = f.duration + ' ' + f.durationType;
          counter++;
        });
      }

      odSettings.OVERDUE_RECALL_TRAINING_DOCS = _.map(this.orSelectedWikiPages, 'WikiPageID').join('|');

      let payload = {
        settingsFor: 'OVERDUE_RECALL',
        settings: odSettings,
        siteID: this.siteID,
        orStatusAppointmentScheduled: this.orStatusAppointmentScheduled,
        orStatusRequireFollowUp: this.orStatusRequireFollowUp,
        orStatusDontFollowUp: this.orStatusDontFollowUp,
        openDentalStatuses: this.orOpenDentalStatuses,
        orListsAssignees: this.orShowAssignments ? this.orListsAssignees : []
      };

      //console.log('Payload:' + JSON.stringify(payload));
      //console.dir(payload);

      try {
        this.saving = true;
        await this.saveSettings(payload);
        await this.init();
        this.$toast.success("Settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    loadUTSettings() {

      this.utSelectedCustomCategoriesForInclude = this._settings.UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_INCLUDE ? JSON.parse(this._settings.UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_INCLUDE.PropertyValue) : [];
      this.utSelectedCustomCategoriesForExclude = this._settings.UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_EXCLUDE ? JSON.parse(this._settings.UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_EXCLUDE.PropertyValue) : [];

      this.utCustomCodes = this._settings.UNSCHEDULED_TREATMENT_CUSTOM_CODES ? JSON.parse(this._settings.UNSCHEDULED_TREATMENT_CUSTOM_CODES.PropertyValue) : [];
      //this.utAccountablePerson= this._settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => e.EmployeeID === this._settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue)[0] : '';
      this.utAccountablePerson= this._settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      
      this.utSelectedIncludeCodes = this._settings.UNSCHEDULED_TREATMENT_INCLUDE_CODES ? JSON.parse(this._settings.UNSCHEDULED_TREATMENT_INCLUDE_CODES.PropertyValue) : [];
      this.utSelectedExcludeCodes = this._settings.UNSCHEDULED_TREATMENT_EXCLUDE_CODES ? JSON.parse(this._settings.UNSCHEDULED_TREATMENT_EXCLUDE_CODES.PropertyValue) : [];

      /* Zero-fee codes are stored as pipe-joined BARE codes, not a JSON blob of option objects
         like the include/exclude lists above. customer.js inserts settings by raw string
         interpolation, so a Descript carrying an apostrophe would break the INSERT — bare codes
         can't. Rehydrating against this.procCodes is safe here: init() awaits getProcCodes()
         before calling loadUTSettings(). Same idiom as UNSCHEDULED_TREATMENT_DEFAULT_PROVIDER. */
      this.utShowZeroFeeCodes = this._settings.UNSCHEDULED_TREATMENT_SHOW_ZERO_FEE_CODES
        ? this._settings.UNSCHEDULED_TREATMENT_SHOW_ZERO_FEE_CODES.PropertyValue === 'TRUE'
        : false;

      if (this._settings.UNSCHEDULED_TREATMENT_ZERO_FEE_CODES && this._settings.UNSCHEDULED_TREATMENT_ZERO_FEE_CODES.PropertyValue) {
        const zeroFee = String(this._settings.UNSCHEDULED_TREATMENT_ZERO_FEE_CODES.PropertyValue).split('|').filter(c => c !== '');
        this.utZeroFeeCodes = (this.procCodes || []).filter(p => zeroFee.includes(p.ProcCode));
      } else {
        this.utZeroFeeCodes = [];
      }

      if (this._settings.UNSCHEDULED_TREATMENT_DEFAULT_PROVIDER && this._settings.UNSCHEDULED_TREATMENT_DEFAULT_PROVIDER.PropertyValue) {
        const provNums = String(this._settings.UNSCHEDULED_TREATMENT_DEFAULT_PROVIDER.PropertyValue).split('|').map(n => parseInt(n, 10)).filter(n => !isNaN(n) && n > 0);
        this.utDefaultProvider = this.uniqueProviders.filter(p => provNums.includes(p.ProvNum));
      } else {
        this.utDefaultProvider = [];
      }
      this.utDailyCalls = this._settings.UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL ? this._settings.UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL.PropertyValue : '';
      this.utWeeklyCalls = this._settings.UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL ? this._settings.UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL.PropertyValue : '';
      this.utMonthlyCalls = this._settings.UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL ? this._settings.UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL.PropertyValue : '';
      this.utMaxNumberOfFollowups= this._settings.UNSCHEDULED_TREATMENT_MAX_FOLLOWUPS ? parseInt(this._settings.UNSCHEDULED_TREATMENT_MAX_FOLLOWUPS.PropertyValue) : '';
      
       
      if (this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY) {
        if (this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY.PropertyValue !== '') {
          this.utSelectedFollowupFrequency = "1";
          this.utAutoFrequencyDuration = this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY.PropertyValue.split(' ')[0];
          this.utAutoFrequencyDurationType = this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY.PropertyValue.split(' ')[1];
        }
        else {
          this.utAutoFrequencyDuration = '';
          this.utAutoFrequencyDurationType = '';
        }
      }
      
      /*
      if(this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY) {
        if(this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY.PropertyValue !== '')
          this.utAutoFrequencyDurationType = this._settings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY.PropertyValue.split(' ')[1];
        else
          this.utAutoFrequencyDurationType = '';
      }
      */

      if(this._settings.UNSCHEDULED_TREATMENT_CUSTOM_FREQUENCY) {
        if(this._settings.UNSCHEDULED_TREATMENT_CUSTOM_FREQUENCY.PropertyValue === 'TRUE') {
          this.utSelectedFollowupFrequency = "2";
          for(var i=1; i<this.utMaxNumberOfFollowups; i++) {
            let temp = 'UNSCHEDULED_TREATMENT_FOLLOWUP_' + i;
            let o = {
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'WEEK'
            }
            this.utCustomFollowUps.push(o);
          }
        }
        else
          this.utSelectedFollowupFrequency = "1";
      }
      
      this.utAllowOverRide= this._settings.UNSCHEDULED_TREATMENT_ALLOW_FOLLOWUP_OVERRIDE ? this._settings.UNSCHEDULED_TREATMENT_ALLOW_FOLLOWUP_OVERRIDE.PropertyValue : '';
      this.utStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 4 && s.TeamioFollowupStatusID === 1);
      this.utStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 4 && s.TeamioFollowupStatusID === 3);
      this.utStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 4 && s.TeamioFollowupStatusID === 6);
      let x = _.union(this.utStatusAppointmentScheduled, this.utStatusDontFollowUp, this.utStatusRequireFollowUp);
      this.utOpenDentalStatuses = _.differenceBy(this.utOpenDentalStatuses, x, 'ClientSystemFollowupStatus');
      this.utCopyToCommLog= this._settings.UNSCHEDULED_TREATMENT_COPY_TO_COMMLOG ? this._settings.UNSCHEDULED_TREATMENT_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.utSelectedWikiPages= this._settings.UNSCHEDULED_TREATMENT_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.UNSCHEDULED_TREATMENT_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];
    },

    async saveUTSettings() {
      //console.log('saving UT settings');
      if(this.utStatusAppointmentScheduled.length > 1) {
        this.$toast.error('You cannot have more than one status for Appointment Scheduled');
        return;
      }
      let utSettings = {
        UNSCHEDULED_TREATMENT_CUSTOM_CODES: this.utCustomCodes ? JSON.stringify(this.utCustomCodes) : '',
        UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_INCLUDE: this.utSelectedCustomCategoriesForInclude ? JSON.stringify(this.utSelectedCustomCategoriesForInclude) : '',
        UNSCHEDULED_TREATMENT_SELECTED_CUSTOM_CATEGORIES_EXCLUDE: this.utSelectedCustomCategoriesForExclude ? JSON.stringify(this.utSelectedCustomCategoriesForExclude) : '',
        UNSCHEDULED_TREATMENT_UNLIMITED_FOLLOWUPS: this.utMaxNumberOfFollowups ? 'FALSE' : 'TRUE',
        //UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID: this.utAccountablePerson ? this.utAccountablePerson.EmployeeID : '',
        UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID: this.utAccountablePerson ? _.map(this.utAccountablePerson, 'EmployeeID').join('|') : '',
        UNSCHEDULED_TREATMENT_INCLUDE_CODES: this.utSelectedIncludeCodes ? JSON.stringify(this.utSelectedIncludeCodes) : '',
        UNSCHEDULED_TREATMENT_EXCLUDE_CODES: this.utSelectedExcludeCodes ? JSON.stringify(this.utSelectedExcludeCodes) : '',
        /* BOTH zero-fee keys go out on EVERY save, including when the toggle is off. The backend
           deletes every UNSCHEDULED_TREATMENT_% row before re-inserting this object, so a key
           omitted here is silently destroyed — and writing the codes while off is what lets an
           office toggle off and back on without re-picking them. */
        UNSCHEDULED_TREATMENT_SHOW_ZERO_FEE_CODES: this.utShowZeroFeeCodes ? 'TRUE' : 'FALSE',
        UNSCHEDULED_TREATMENT_ZERO_FEE_CODES: this.utZeroFeeCodes ? this.utZeroFeeCodes.map(c => c.ProcCode).join('|') : '',
        UNSCHEDULED_TREATMENT_DEFAULT_PROVIDER: this.utDefaultProvider && this.utDefaultProvider.length > 0 ? this.utDefaultProvider.map(p => p.ProvNum).join('|') : '',
        UNSCHEDULED_TREATMENT_DAILY_CALLS_GOAL: this.utDailyCalls,
        UNSCHEDULED_TREATMENT_WEEKLY_CALLS_GOAL: this.utWeeklyCalls,
        UNSCHEDULED_TREATMENT_MONTHLY_CALLS_GOAL: this.utMonthlyCalls,
        UNSCHEDULED_TREATMENT_ALLOW_FOLLOWUP_OVERRIDE: this.utAllowOverRide,
        UNSCHEDULED_TREATMENT_MAX_FOLLOWUPS: this.utMaxNumberOfFollowups,
        UNSCHEDULED_TREATMENT_COPY_TO_COMMLOG: this.utCopyToCommLog ? this.utCopyToCommLog : 'FALSE'
      };
      
      if(parseInt(this.utSelectedFollowupFrequency,10) === 1) {
        utSettings.UNSCHEDULED_TREATMENT_AUTO_FREQUENCY = this.utAutoFrequencyDuration + ' ' + this.utAutoFrequencyDurationType;
      }

      if(parseInt(this.utSelectedFollowupFrequency,10) === 2) {
        utSettings.UNSCHEDULED_TREATMENT_CUSTOM_FREQUENCY = 'TRUE';
        let counter = 1;
        this.utCustomFollowUps.forEach(function(f) {
          let i = 'UNSCHEDULED_TREATMENT_FOLLOWUP_' + counter;
          utSettings[i] = f.duration + ' ' + f.durationType;
          counter++;
        });
      }

      
      utSettings.UNSCHEDULED_TREATMENT_TRAINING_DOCS = _.map(this.utSelectedWikiPages, 'WikiPageID').join('|');      

      let payload = {
        settingsFor: 'UNSCHEDULED_TREATMENT',
        settings: utSettings,
        siteID: this.siteID,
        utStatusAppointmentScheduled: this.utStatusAppointmentScheduled,
        utStatusRequireFollowUp: this.utStatusRequireFollowUp,
        utStatusDontFollowUp: this.utStatusDontFollowUp,
        openDentalStatuses: this.utOpenDentalStatuses,        
        utListsAssignees: this.utShowAssignments ? this.utListsAssignees : []
      };

      //console.log('Payload:' + JSON.stringify(payload));
      //console.dir(payload);
      
      try {
        this.saving = true;
        await this.saveSettings(payload);
        await this.init();
        this.$toast.success("Settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    loadAgingSettings() {

      this.ocAccountablePerson= this._settings.OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      this.opAccountablePerson= this._settings.OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      this.ppAccountablePerson= this._settings.PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      this.pbAccountablePerson= this._settings.PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';

      this.ocFollowupDuration = this._settings.OUTSTANDING_CLAIM_FOLLOWUP_DURATION ? this._settings.OUTSTANDING_CLAIM_FOLLOWUP_DURATION.PropertyValue : '';
      this.ocFollowupDurationType = this._settings.OUTSTANDING_CLAIM_FOLLOWUP_DURATION_TYPE ? this._settings.OUTSTANDING_CLAIM_FOLLOWUP_DURATION_TYPE.PropertyValue : '';

      this.ppDailyCalls = this._settings.PROCESSED_PREAUTHS_DAILY_CALLS_GOAL ? this._settings.PROCESSED_PREAUTHS_DAILY_CALLS_GOAL.PropertyValue : '';
      this.ppWeeklyCalls = this._settings.PROCESSED_PREAUTHS_WEEKLY_CALLS_GOAL ? this._settings.PROCESSED_PREAUTHS_WEEKLY_CALLS_GOAL.PropertyValue : '';
      this.ppMonthlyCalls = this._settings.PROCESSED_PREAUTHS_MONTHLY_CALLS_GOAL ? this._settings.PROCESSED_PREAUTHS_MONTHLY_CALLS_GOAL.PropertyValue : '';
      this.ppMaxNumberOfFollowups= this._settings.PROCESSED_PREAUTHS_MAX_FOLLOWUPS ? parseInt(this._settings.PROCESSED_PREAUTHS_MAX_FOLLOWUPS.PropertyValue) : '';

      if (this._settings.PROCESSED_PREAUTHS_AUTO_FREQUENCY) {
        if (this._settings.PROCESSED_PREAUTHS_AUTO_FREQUENCY.PropertyValue !== '') {
          this.ppSelectedFollowupFrequency = "1";
          this.ppAutoFrequencyDuration = this._settings.PROCESSED_PREAUTHS_AUTO_FREQUENCY.PropertyValue.split(' ')[0];
          this.ppAutoFrequencyDurationType = this._settings.PROCESSED_PREAUTHS_AUTO_FREQUENCY.PropertyValue.split(' ')[1];
        }
        else {
          this.ppSelectedFollowupFrequency = "2";
          this.ppAutoFrequencyDuration = '';
          this.ppAutoFrequencyDurationType = '';
        }
      }

      if(this._settings.PROCESSED_PREAUTHS_CUSTOM_FREQUENCY) {
        if(this._settings.PROCESSED_PREAUTHS_CUSTOM_FREQUENCY.PropertyValue === 'TRUE') {
          this.ppSelectedFollowupFrequency = 2;
          this.ppCustomFollowUps = [];
          for(var i=1; i<this.ppMaxNumberOfFollowups; i++) {
            let temp = 'PROCESSED_PREAUTHS_FOLLOWUP_' + i;
            let o = {
              duration: this._settings[temp].PropertyValue.split(' ')[0],
              durationType: this._settings[temp].PropertyValue.split(' ')[1]
            }
            //console.log(`Loading overdue recall custom followup object:${JSON.stringify(o)}`);
            this.ppCustomFollowUps.push(o);
          }
        }
        else
          this.ppSelectedFollowupFrequency = 1;
      }

      this.ppAllowOverRide= this._settings.PROCESSED_PREAUTHS_ALLOW_FOLLOWUP_OVERRIDE ? this._settings.PROCESSED_PREAUTHS_ALLOW_FOLLOWUP_OVERRIDE.PropertyValue : '';

      this.ocStatusClaimProcessed = this.statuses.filter(s => s.TaskTypeID === 2 && s.TeamioFollowupStatusID === 5);
      this.ocStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 2 && s.TeamioFollowupStatusID === 3);
      this.ocStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 2 && s.TeamioFollowupStatusID === 6);

      this.opStatusClaimProcessed = this.statuses.filter(s => s.TaskTypeID === 5 && s.TeamioFollowupStatusID === 5);
      this.opStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 5 && s.TeamioFollowupStatusID === 3);
      this.opStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 5 && s.TeamioFollowupStatusID === 6);

      this.ppStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 6 && s.TeamioFollowupStatusID === 1);
      this.ppStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 6 && s.TeamioFollowupStatusID === 3);
      this.ppStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 6 && s.TeamioFollowupStatusID === 6);

      this.pbStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 7 && s.TeamioFollowupStatusID === 5);
      this.pbStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 7 && s.TeamioFollowupStatusID === 3);
      this.pbStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 7 && s.TeamioFollowupStatusID === 6);


      let x = _.union(this.ocStatusClaimProcessed, this.ocStatusDontFollowUp, this.ocStatusRequireFollowUp);
      this.ocOpenDentalStatuses = _.differenceBy(this.ocOpenDentalStatuses, x, 'ClientSystemFollowupStatus');
      this.ocCopyToCommLog = this._settings.OUTSTANDING_CLAIM_COPY_TO_COMMLOG ? this._settings.OUTSTANDING_CLAIM_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.ocCopyToStatusHistory = this._settings.OUTSTANDING_CLAIM_COPY_TO_OD_CLAIM_HISTORY ? this._settings.OUTSTANDING_CLAIM_COPY_TO_OD_CLAIM_HISTORY.PropertyValue === 'TRUE' ? true : 'FALSE' : 'FALSE',
      this.ocSelectedWikiPages= this._settings.OUTSTANDING_CLAIM_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.OUTSTANDING_CLAIM_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];

      let y = _.union(this.opStatusClaimProcessed, this.opStatusDontFollowUp, this.opStatusRequireFollowUp);
      this.opOpenDentalStatuses = _.differenceBy(this.opOpenDentalStatuses, y, 'ClientSystemFollowupStatus');
      this.opCopyToCommLog= this._settings.OUTSTANDING_PREAUTHS_COPY_TO_COMMLOG ? this._settings.OUTSTANDING_PREAUTHS_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.opCopyToStatusHistory = this._settings.OUTSTANDING_PREAUTHS_COPY_TO_OD_CLAIM_HISTORY ? this._settings.OUTSTANDING_PREAUTHS_COPY_TO_OD_CLAIM_HISTORY.PropertyValue=== 'TRUE' ? true : 'FALSE' : 'FALSE',
      this.opSelectedWikiPages= this._settings.OUTSTANDING_PREAUTHS_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.OUTSTANDING_PREAUTHS_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];

      let z = _.union(this.ppStatusAppointmentScheduled, this.ppStatusDontFollowUp, this.ppStatusRequireFollowUp);
      this.ppOpenDentalStatuses = _.differenceBy(this.ppOpenDentalStatuses, z, 'ClientSystemFollowupStatus');
      this.ppCopyToCommLog= this._settings.PROCESSED_PREAUTHS_COPY_TO_COMMLOG ? this._settings.PROCESSED_PREAUTHS_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.ppSelectedWikiPages= this._settings.PROCESSED_PREAUTHS_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.PROCESSED_PREAUTHS_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];

      let x1 = _.union(this.pbStatusAppointmentScheduled, this.pbStatusDontFollowUp, this.pbStatusRequireFollowUp);
      this.pbOpenDentalStatuses = _.differenceBy(this.pbOpenDentalStatuses, x1, 'ClientSystemFollowupStatus');
      this.pbCopyToCommLog= this._settings.PATIENT_BALANCES_COPY_TO_COMMLOG ? this._settings.PATIENT_BALANCES_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.pbSelectedWikiPages= this._settings.PATIENT_BALANCES_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.PATIENT_BALANCES_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];
    },

    async saveAgingSettings() {
      //console.log('saving Aging settings');
      if(this.ppStatusAppointmentScheduled.length > 1 || this.pbStatusAppointmentScheduled.length > 1) {
        this.$toast.error('You cannot have more than one status for Appointment Scheduled');
        return;
      }
      let agingSettings = {
        //OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID: this.ocAccountablePerson ? this.ocAccountablePerson.EmployeeID : '',
        OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID: this.ocAccountablePerson ? _.map(this.ocAccountablePerson, 'EmployeeID').join('|') : '',
        OUTSTANDING_CLAIM_COPY_TO_COMMLOG: this.ocCopyToCommLog ? this.ocCopyToCommLog : 'FALSE',
        OUTSTANDING_CLAIM_COPY_TO_OD_CLAIM_HISTORY: this.ocCopyToStatusHistory ? this.ocCopyToStatusHistory === true ? 'TRUE' : 'FALSE' : 'FALSE',

        OUTSTANDING_CLAIM_FOLLOWUP_DURATION: this.ocFollowupDuration,
        OUTSTANDING_CLAIM_FOLLOWUP_DURATION_TYPE: this.ocFollowupDurationType,
        
        //OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID: this.opAccountablePerson ? this.opAccountablePerson.EmployeeID : '',
        OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID: this.opAccountablePerson ? _.map(this.opAccountablePerson, 'EmployeeID').join('|') : '',
        OUTSTANDING_PREAUTHS_COPY_TO_COMMLOG: this.opCopyToCommLog ? this.opCopyToCommLog : 'FALSE',
        OUTSTANDING_PREAUTHS_COPY_TO_OD_CLAIM_HISTORY: this.opCopyToStatusHistory ? this.opCopyToStatusHistory=== true ? 'TRUE' : 'FALSE' : 'FALSE',

        PROCESSED_PREAUTHS_UNLIMITED_FOLLOWUPS: this.ppMaxNumberOfFollowups ? 'FALSE' : 'TRUE',
        //PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID: this.ppAccountablePerson ? this.ppAccountablePerson.EmployeeID : '',
        PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID: this.ppAccountablePerson ? _.map(this.ppAccountablePerson, 'EmployeeID').join('|') : '',
        PROCESSED_PREAUTHS_DAILY_CALLS_GOAL: this.ppDailyCalls,
        PROCESSED_PREAUTHS_WEEKLY_CALLS_GOAL: this.ppWeeklyCalls,
        PROCESSED_PREAUTHS_MONTHLY_CALLS_GOAL: this.ppMonthlyCalls,
        PROCESSED_PREAUTHS_ALLOW_FOLLOWUP_OVERRIDE: this.ppAllowOverRide,
        PROCESSED_PREAUTHS_MAX_FOLLOWUPS: this.ppMaxNumberOfFollowups,
        PROCESSED_PREAUTHS_COPY_TO_COMMLOG: this.ppCopyToCommLog ? this.ppCopyToCommLog : 'FALSE',

        //PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID: this.pbAccountablePerson ? this.pbAccountablePerson.EmployeeID : '',
        PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID: this.pbAccountablePerson ? _.map(this.pbAccountablePerson, 'EmployeeID').join('|') : '',
        PATIENT_BALANCES_COPY_TO_COMMLOG: this.pbCopyToCommLog ? this.pbCopyToCommLog : 'FALSE',
      };

      if(parseInt(this.ppSelectedFollowupFrequency,10) === 1) {
          agingSettings.PROCESSED_PREAUTHS_AUTO_FREQUENCY = this.ppAutoFrequencyDuration + ' ' + this.ppAutoFrequencyDurationType;
        }

      if(parseInt(this.ppSelectedFollowupFrequency,10) === 2) {
        agingSettings.PROCESSED_PREAUTHS_CUSTOM_FREQUENCY = 'TRUE';
        let counter = 1;
        this.ppCustomFollowUps.forEach(function(f) {
          let i = 'PROCESSED_PREAUTHS_FOLLOWUP_' + counter;
          agingSettings[i] = f.duration + ' ' + f.durationType;
          counter++;
        });
      }
      
      agingSettings.OUTSTANDING_CLAIM_TRAINING_DOCS = _.map(this.ocSelectedWikiPages, 'WikiPageID').join('|');
      agingSettings.OUTSTANDING_PREAUTHS_TRAINING_DOCS = _.map(this.opSelectedWikiPages, 'WikiPageID').join('|');      
      agingSettings.PROCESSED_PREAUTHS_TRAINING_DOCS = _.map(this.ppSelectedWikiPages, 'WikiPageID').join('|');
      agingSettings.PATIENT_BALANCES_TRAINING_DOCS = _.map(this.pbSelectedWikiPages, 'WikiPageID').join('|');

      let payload = {
        settingsFor: 'AGING',
        settings: agingSettings,
        siteID: this.siteID,

        ocStatusClaimProcessed: this.ocStatusClaimProcessed,
        ocStatusRequireFollowUp: this.ocStatusRequireFollowUp,
        ocStatusDontFollowUp: this.ocStatusDontFollowUp,
        ocOpenDentalStatuses: this.ocOpenDentalStatuses,

        opStatusClaimProcessed: this.opStatusClaimProcessed,
        opStatusRequireFollowUp: this.opStatusRequireFollowUp,
        opStatusDontFollowUp: this.opStatusDontFollowUp,
        opOpenDentalStatuses: this.opOpenDentalStatuses,

        ppStatusAppointmentScheduled: this.ppStatusAppointmentScheduled,
        ppStatusRequireFollowUp: this.ppStatusRequireFollowUp,
        ppStatusDontFollowUp: this.ppStatusDontFollowUp,
        ppOpenDentalStatuses: this.ppOpenDentalStatuses,

        pbStatusAppointmentScheduled: this.pbStatusAppointmentScheduled,
        pbStatusRequireFollowUp: this.pbStatusRequireFollowUp,
        pbStatusDontFollowUp: this.pbStatusDontFollowUp,
        pbOpenDentalStatuses: this.pbOpenDentalStatuses,
      };

      //console.log('Payload:' + JSON.stringify(payload));
      //console.dir(payload);
      
      try {
        this.saving = true;
        await this.saveSettings(payload);
        await this.init();
        this.$toast.success("Settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    loadBaSettings() {
      //console.dir(this._settings);
      //this.baAccountablePerson= this._settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => e.EmployeeID === this._settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue)[0] : '';
      this.baAccountablePerson= this._settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID ? this.employees.filter(e => this._settings.BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID.PropertyValue.split('|').includes(e.EmployeeID)) : '';
      this.baDailyCalls = this._settings.BROKEN_APPOINTMENTS_DAILY_CALLS_GOAL ? this._settings.BROKEN_APPOINTMENTS_DAILY_CALLS_GOAL.PropertyValue : '';
      this.baWeeklyCalls = this._settings.BROKEN_APPOINTMENTS_WEEKLY_CALLS_GOAL ? this._settings.BROKEN_APPOINTMENTS_WEEKLY_CALLS_GOAL.PropertyValue : '';
      this.baMonthlyCalls = this._settings.BROKEN_APPOINTMENTS_MONTHLY_CALLS_GOAL ? this._settings.BROKEN_APPOINTMENTS_MONTHLY_CALLS_GOAL.PropertyValue : '';
      this.baMaxNumberOfFollowups= this._settings.BROKEN_APPOINTMENTS_MAX_FOLLOWUPS ? parseInt(this._settings.BROKEN_APPOINTMENTS_MAX_FOLLOWUPS.PropertyValue) : '';
      
       
      if (this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY) {
        if (this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY.PropertyValue !== '')
          this.baAutoFrequencyDuration = this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY.PropertyValue.split(' ')[0];
        else
          this.baAutoFrequencyDuration = '';
      }
      
      if(this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY) {
        if(this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY.PropertyValue !== '')
          this.baAutoFrequencyDurationType = this._settings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY.PropertyValue.split(' ')[1];
        else
          this.baAutoFrequencyDurationType = '';
      }

      if(this._settings.BROKEN_APPOINTMENTS_CUSTOM_FREQUENCY) {
        if(this._settings.BROKEN_APPOINTMENTS_CUSTOM_FREQUENCY.PropertyValue === 'TRUE') {
          this.baSelectedFollowupFrequency = "2";
          this.baCustomFollowUps = [];

          for(var i=1; i<this.baMaxNumberOfFollowups; i++) {
            let temp = 'BROKEN_APPOINTMENTS_FOLLOWUP_' + i;
            let o = {
              duration: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[0] : 1,
              durationType: this._settings[temp] ? this._settings[temp].PropertyValue.split(' ')[1] : 'WEEK'
            }
            //console.log(o);
            //arr.push(o);
            this.baCustomFollowUps.push(o);
          }
          //this.baCustomFollowUps = arr;
          //console.log('baCustomFollowUps', this.baCustomFollowUps);
        }
        else
          this.baSelectedFollowupFrequency = "1";
      }
      
      this.baAllowOverRide= this._settings.BROKEN_APPOINTMENTS_ALLOW_FOLLOWUP_OVERRIDE ? this._settings.BROKEN_APPOINTMENTS_ALLOW_FOLLOWUP_OVERRIDE.PropertyValue : '';
      this.baStatusAppointmentScheduled = this.statuses.filter(s => s.TaskTypeID === 8 && s.TeamioFollowupStatusID === 1);
      this.baStatusDontFollowUp = this.statuses.filter(s => s.TaskTypeID === 8 && s.TeamioFollowupStatusID === 3);
      this.baStatusRequireFollowUp = this.statuses.filter(s => s.TaskTypeID === 8 && s.TeamioFollowupStatusID === 6);
      let x = _.union(this.baStatusAppointmentScheduled, this.baStatusDontFollowUp, this.baStatusRequireFollowUp);
      this.baOpenDentalStatuses = _.differenceBy(this.baOpenDentalStatuses, x, 'ClientSystemFollowupStatus');
      this.baCopyToCommLog= this._settings.BROKEN_APPOINTMENTS_COPY_TO_COMMLOG ? this._settings.BROKEN_APPOINTMENTS_COPY_TO_COMMLOG.PropertyValue : 'FALSE',
      this.baSelectedWikiPages= this._settings.BROKEN_APPOINTMENTS_TRAINING_DOCS ? this.wikiPages[0].filter(p => this._settings.BROKEN_APPOINTMENTS_TRAINING_DOCS.PropertyValue.split('|').indexOf(p.WikiPageID) !== -1) : [];
      this.baAdjustSelectedValues= this._settings.BROKEN_APPOINTMENTS_SELECTED_ADJUSTMENTS ? this._settings.BROKEN_APPOINTMENTS_SELECTED_ADJUSTMENTS.PropertyValue.split('|') : [];
    },

    async saveBaSettings() {
      //console.log('saving Broken Appointment settings');
      if(this.baStatusAppointmentScheduled.length > 1) {
        this.$toast.error('You cannot have more than one status for Appointment Scheduled');
        return;
      }

      let baSettings = {
        BROKEN_APPOINTMENTS_UNLIMITED_FOLLOWUPS: this.baMaxNumberOfFollowups ? 'FALSE' : 'TRUE',
        BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID: this.baAccountablePerson ? _.map(this.baAccountablePerson, 'EmployeeID').join('|') : '',
        BROKEN_APPOINTMENTS_DAILY_CALLS_GOAL: this.baDailyCalls,
        BROKEN_APPOINTMENTS_WEEKLY_CALLS_GOAL: this.baWeeklyCalls,
        BROKEN_APPOINTMENTS_MONTHLY_CALLS_GOAL: this.baMonthlyCalls,
        BROKEN_APPOINTMENTS_ALLOW_FOLLOWUP_OVERRIDE: this.baAllowOverRide,
        BROKEN_APPOINTMENTS_MAX_FOLLOWUPS: this.baMaxNumberOfFollowups,
        BROKEN_APPOINTMENTS_COPY_TO_COMMLOG: this.baCopyToCommLog ? this.baCopyToCommLog : 'FALSE',
        BROKEN_APPOINTMENTS_SELECTED_ADJUSTMENTS: this.baAdjustSelectedValues.length !== 0 ? this.baAdjustSelectedValues.join('|') : '14|15',
        BROKEN_APPOINTMENTS_CODES: this.baProcCodes && this.baProcCodes.length > 0 ? this.baProcCodes.join('|') : 'D9986|D9987'
      };

      if(this.baProcCodes && this.baProcCodes.length > 0)
        localStorage.setItem('brokenApptCodes', this.baProcCodes.join('|'));

      if(this.baAdjustSelectedValues && this.baAdjustSelectedValues.length > 0)
        localStorage.setItem('brokenApptAdjustments', this.baAdjustSelectedValues.join('|'));
      
      if(parseInt(this.baSelectedFollowupFrequency,10) === 1) {
        baSettings.BROKEN_APPOINTMENTS_AUTO_FREQUENCY = this.baAutoFrequencyDuration + ' ' + this.baAutoFrequencyDurationType;
      }

      if(parseInt(this.baSelectedFollowupFrequency,10) === 2) {
        baSettings.BROKEN_APPOINTMENTS_CUSTOM_FREQUENCY = 'TRUE';
        let counter = 1;
        this.baCustomFollowUps.forEach(function(f) {
          let i = 'BROKEN_APPOINTMENTS_FOLLOWUP_' + counter;
          baSettings[i] = f.duration + ' ' + f.durationType;
          counter++;
        });
      }

      
      baSettings.BROKEN_APPOINTMENTS_TRAINING_DOCS = _.map(this.baSelectedWikiPages, 'WikiPageID').join('|');

      let payload = {
        settingsFor: 'BROKEN_APPOINTMENT',
        settings: baSettings,
        siteID: this.siteID,
        baStatusAppointmentScheduled: this.baStatusAppointmentScheduled,
        baStatusRequireFollowUp: this.baStatusRequireFollowUp,
        baStatusDontFollowUp: this.baStatusDontFollowUp,
        openDentalStatuses: this.baOpenDentalStatuses
      };

      //console.log('Payload:' + JSON.stringify(payload));
      //console.dir(payload);

      try {
        this.saving = true;
        await this.saveSettings(payload);
        await this.init();
        this.$toast.success("Settings saved successfully!");
      } catch(error) {
        this.$toast.error('Failed to save settings. Please try again.');
        console.error('Save settings error:', error);
      } finally {
        this.saving = false;
      }
    },

    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },

    searchCodes(s, codes) { 
      //console.log('in searchCodes', s, codes);
      s = s.trim();      
      if(s !== '') {
        if (s.indexOf('*') > -1) {
          let str = s.substring(0,s.length-1);
          //console.log('str', str);          
          for(let option of this.procCodes) {
            //console.dir(option);
            if(option.ProcCode.toUpperCase().startsWith(str.toUpperCase())) {
              //console.dir(option);
              codes.push(option);
            }
          }
        }
      }
    },

  },

  computed: {
    ...mapState({
        statuses: state => state.customer.statuses,
        queryResults : state => state.teamio.queryResults,
        procCodes: state => state.customer.procCodes
    }),

    // Email Reports tab is visible to Super Admin and Admin (RoleID 1, 2)
    canViewEmailReports() {
      return this.user && (this.user.Role === 'Super Admin' || this.user.Role === 'Admin');
    },

    // Payments tab is visible to Super Admin and Admin. The office self-serves
    // payment setup (Card→PayType mapping, the Open Dental posting decision, and
    // turning collection on); the Moolah provider selection + credentials stay
    // Super-Admin-only inside PaymentSettings (Teamio connects the processor).
    canViewPaymentSettings() {
      if (this.isDemoSession) return false;
      return this.user && (this.user.Role === 'Super Admin' || this.user.Role === 'Admin');
    },

    // Email Settings tab: Super Admin manages senders globally; Admins self-serve
    // email verification for their own site (new sites acquiring email capability).
    canViewEmailSettings() {
      if (this.isDemoSession) return false;
      return this.user && (this.user.Role === 'Super Admin' || this.user.Role === 'Admin');
    },

    // Demo site (plan Task 6.5): payment setup, email senders and the Mango Voice connection are not part of the demo.
    isDemoSession() {
      return !!this.$store && this.$store.getters['customer/isDemo'] === true;
    },

    // Bank Connection tab is only visible to Super Admin (feature in development)
    canViewBankConnection() {
      return this.user && this.user.Role === 'Super Admin';
    },

    // Slack tab is only visible to Super Admin
    canViewSlack() {
      return this.user && this.user.Role === 'Super Admin';
    },

    // Action Center clearing scope (General tab): Super Admin and Admin only.
    canEditActionCenterScope() {
      return !!(this.user && (this.user.Role === 'Super Admin' || this.user.Role === 'Admin'));
    },

    uniqueProviders() {
      if (!this.providers) return [];
      const seen = new Set();
      return this.providers.filter(p => {
        if (seen.has(p.ProvNum)) return false;
        seen.add(p.ProvNum);
        return true;
      });
    },

    slackChannelOptions() {
      // Sort channels: bot-joined first, then others
      const sorted = [...this.slackChannels].sort((a, b) => {
        if (a.is_member && !b.is_member) return -1;
        if (!a.is_member && b.is_member) return 1;
        return a.name.localeCompare(b.name);
      });

      return sorted.map(channel => ({
        value: channel.id,
        text: `${channel.is_private ? '🔒 ' : '#'}${channel.name}${channel.is_member ? ' ✓' : ' (invite bot first)'}`
      }));
    },

    // Mango Voice webhook URL (without token)
    mangoVoiceWebhookUrl() {
      const apiUrl = process.env.VUE_APP_TEAMIO_API_URL || 'https://api.teamio.app';
      return `${apiUrl}/mango-voice/webhook/${this.siteID}`;
    },

    // Mango Voice full webhook URL (with token)
    mangoVoiceFullWebhookUrl() {
      if (!this.mangoVoiceToken) return this.mangoVoiceWebhookUrl;
      return `${this.mangoVoiceWebhookUrl}?token=${this.mangoVoiceToken}`;
    },

    utCustomCategories() {
      if(this.utCustomCodes) {
        return _.map(this.utCustomCodes, 'categoryName');
      }
    },

    trackingBA() {
      if(this.queryResults[0] && this.queryResults[0].data.length > 0 && this.queryResults[0].data[0].length > 1) {
        let pc = this.queryResults[0].data[0][0].ValueString
        let baAdjust = this.queryResults[0].data[0][1].ValueString
        if (pc === '0' && baAdjust === '0')
          return false;
        else
          return true;
      }
    },

    baProcCodes: {
      get: function() {
        if(this.queryResults[0] && this.queryResults[0].data.length > 0 && this.queryResults[0].data[0].length > 0) {
          let pc = this.queryResults[0].data[0][0].ValueString
          let ret = [];
          switch(pc) {
            case '0' :  break;
            case '1' : ret.push('D9986'); break;
            case '2' : ret.push('D9987'); break;
            case '3' : ret = ['D9986', 'D9987']; break;
            default: break;
          }
          return ret;
        }
      },

      set: function(val) {

      }
    },

    baAdjustments() {
      if(this.queryResults[0] && this.queryResults[0].data.length > 0)
          return this.queryResults[0].data[1];
    },

    // is the client using Broken Appointment Adjustments in their OD?
    baAdjustmentOn() {
      if(this.queryResults[0] && this.queryResults[0].data.length > 0 && this.queryResults[0].data[0].length > 1) {
        let adjOn = this.queryResults[0].data[0][1].ValueString;
        if(adjOn === '0')
          return false;
        else
          return true;
      }
    },

    // these are all different types of Positive Adjustments client offices have in their OD
    baAdjustmentsValues() {
      if(this.queryResults[0] && this.queryResults[0].data.length > 0) {
        return this.queryResults[0].data[2];
      }
    },

    employeeLists() {
      if(this.queryResults[1] && this.queryResults[1].data.length > 0) {
        return this.queryResults[1].data;
      }
    },

    /*
    orLists() {
      if(this.employeeLists && this.allSettings) {
        return this.employeeLists.filter(e => e.TaskTypeID === 3 && e.AssignedToEmpID === this.allSettings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue);
      }
    },

    orListsAssignees() {
      let retVal = [];
      if(this.orLists) {
        let _this = this;
        this.orLists.forEach(function(list) {
        retVal.push({
            list: list,
            assignedTo: _this.employees.filter(e => e.EmployeeID ===list.AssignedToEmpID)
          })
        });
        return retVal;
      }
    },

    // Removing this functions below since we're now allowing multiple people to be assigned. No need to track this

    orAccountablePersonChanged() {
      if(this.allSettings 
        && this.allSettings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID 
        && this.orAccountablePerson
        && this.orAccountablePerson.EmployeeID !== this.allSettings.OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID.PropertyValue)
        return true;
      else
        return false;
    },

    orShowAssignments() {
      if (this.orAccountablePersonChanged && this.orLists && this.orLists.length > 0)
        return true;
      else
        return false;
    },

    */

   /*
    utLists() {
      if(this.employeeLists && this.allSettings && this.allSettings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID) {
        return this.employeeLists.filter(e => e.TaskTypeID === 4 && e.AssignedToEmpID === this.allSettings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue);
      }
    },

    utListsAssignees() {
      let retVal = [];
      if(this.utLists) {
        let _this = this;
        this.utLists.forEach(function(list) {
        retVal.push({
            list: list,
            assignedTo: _this.employees.filter(e => e.EmployeeID ===list.AssignedToEmpID)
          })
        });
        return retVal;
      }
    },

    utAccountablePersonChanged() {
      if(this.allSettings 
        && this.allSettings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID 
        && this.utAccountablePerson
        && this.utAccountablePerson.EmployeeID !== this.allSettings.UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID.PropertyValue)
        return true;
      else
        return false;
    },

    utShowAssignments() {
      if (this.utAccountablePersonChanged && this.utLists && this.utLists.length > 0)
        return true;
      else
        return false;
    },

    */
  },

  watch: {
    utSelectedCustomCategoriesForInclude(newVal, oldVal) {
      //console.log('include changed', newVal, oldVal);            
      let orig = this.utSelectedIncludeCodes;
      for(let cat of newVal) {
        //console.log('now getting proc codes for cat', cat);
        let procCodes = this.getProcCodesForCustomCategory(cat);
        //console.log(procCodes);        
        for(let code of procCodes) {   
          let foundObj = this.utSelectedIncludeCodes.find(obj => obj.ProcCode === code.ProcCode && obj.Descript === code.Descript);
          if(!foundObj)
            orig.push(code);
        }
      }
      this.$set(this, 'utSelectedIncludeCodes', orig);
    },

    utSelectedCustomCategoriesForExclude(newVal, oldVal) {
      //console.log('exclude changed', newVal, oldVal);            
      let orig = this.utSelectedExcludeCodes;
      for(let cat of newVal) {
        //console.log('now getting proc codes for cat', cat);
        let procCodes = this.getProcCodesForCustomCategory(cat);
        //console.log(procCodes);        
        for(let code of procCodes) {
          let foundObj = this.utSelectedExcludeCodes.find(obj => obj.ProcCode === code.ProcCode && obj.Descript === code.Descript);        
          if(!foundObj)
            orig.push(code);
        }
      }
      this.$set(this, 'utSelectedExcludeCodes', orig);
    },
  }
};
</script>

<style src="./Settings.scss" lang="scss"></style>
<style lang='scss'>
@import "vue-select/src/scss/vue-select.scss";

  .tab_header{
    background-color: #f8f9fa !important;
    padding: 0.75rem 1rem !important;
    width: fit-content;
    border-radius: 8px;
    text-align: center;
    border: 1px solid #e0e0e0;
    color: #333;
    font-weight: 600;
  }
  .sec_header{
    color: #333 !important;
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #eee;

    &.text-success {
      color: #333 !important;
    }
  }
  .w-fit{
    width: fit-content !important;
  }
  .b-rad-5{
    border-radius: 5px !important;
  }
  .b-rad-10{
    border-radius: 10px !important;
  }
  .b-rad-15{
    border-radius: 15px !important;
  }
  .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #41b883 !important;
    background-color: #41b883 !important;
  }
  .custom-control-input:checked ~ .custom-control-label::after{
    color: azure !important;
  }

/* styled time zone selectbox */
  .timezone_city{
    width: 300px;

    ul.vs__dropdown-menu li, ul.vs__dropdown-menu li:not(:hover){
      background-color: #fff;
      color: #000;
      padding: 10px 5px;
      border-bottom: 1px solid #ccc;
      transition: 0.4s;
    }
    
    ul.vs__dropdown-menu li:hover{
      background-color: #3abf94;
      color: #fff;
    }
    
  }
/* styled time zone selectbox */

/* Zero-Fee Procedure Codes toggle.
   NOTE: this component's <style> block is NOT scoped, so every rule here is global. The toggle
   markup is borrowed from EmailReportsTab.vue (.er-toggle), whose CSS *is* scoped and therefore
   can't be reused. Everything below is nested under .ut-zero-fee-section on purpose — that
   wrapper is what keeps these generic-sounding class names from leaking onto other pages. */
/* Section separator on the Unscheduled Treatment tab.
   These blocks are NESTED .info-section elements, and Settings.scss strips the border and
   background off a nested one (".info-section .info-section { border: none; ... }"), so the
   sections ran together with nothing between them. This puts the rule back as a top border plus
   breathing room, which is why it is a border-top on the section rather than an <hr>: no extra
   element, and it lands above the heading where the eye expects the break.

   The selector is doubled deliberately. Settings.scss's `.info-section .info-section` is
   specificity (0,2,0), so a plain `.ut-section-divider` (0,1,0) loses the padding fight. Matching
   the nesting takes this to (0,3,0) and wins outright — no !important, and no dependence on which
   <style> block webpack emits first. */
.info-section .info-section.ut-section-divider {
  border-top: 1px solid #e0e0e0;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
}

.ut-zero-fee-section {

  /* Switch + the sentence it controls, on one line. align-items: flex-start keeps the switch
     pinned to the first line when the sentence wraps on a narrow window. */
  .ut-zero-fee-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 0.75rem;
  }

  .ut-toggle {
    /* flex-shrink: 0 — without it the switch squashes into an ellipse as the sentence grows. */
    flex: 0 0 auto;
    display: inline-block;
    position: relative;
    width: 38px;
    height: 20px;
    cursor: pointer;
    margin: 2px 0 0 0;

    /* The native box is hidden but still focusable/checkable: opacity 0 rather than
       display: none, so it stays in the tab order and the label click still toggles it. */
    input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
      margin: 0;
    }
  }

  .ut-toggle-slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 38px;
    height: 20px;
    background: #ced4da;
    border-radius: 10px;
    transition: background 0.2s;

    &::after {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 50%;
      top: 2px;
      left: 2px;
      transition: transform 0.2s;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }
  }

  .ut-toggle input:checked + .ut-toggle-slider {
    background: #3abf94;

    &::after { transform: translateX(18px); }
  }

  .ut-toggle input:focus-visible + .ut-toggle-slider {
    box-shadow: 0 0 0 3px rgba(58, 191, 148, 0.35);
  }

  .ut-zero-fee-help {
    color: #6c757d;
    font-size: 0.85rem;
    line-height: 1.35;
  }

  .ut-zero-fee-label {
    margin-bottom: 0.35rem;
  }
}
</style>

<style lang="scss" scoped>
/* Action Center clearing setting (General tab). Two global rules restyle every .custom-radio on this page:
   Settings.scss `.custom-radio { display: inline-block !important; padding-left: 10px !important }` and the
   unscoped pill in MyAccount.vue (`.custom-radio` padding + border, highlighted when checked). Together they
   put the stacked options side by side, with each radio circle hanging outside its box. Stack the options
   and leave room for the circle inside the box. */
.ac-dismiss-scope-setting ::v-deep .custom-radio {
  display: block !important;
  max-width: 520px;
  padding-left: 2.25rem !important;
}
</style>